<template>
  <div>
    <div id="pdfDom">
      <evaluator-header class="mainHeader" @logout="logoutClick"></evaluator-header>
      <div class="cssOuterBox clearfix">
        <div id='cssMainBody' :class="[
          'cssMainBody',
          riskLevel === 1 ? 'perfect'
            : riskLevel === 2 ? 'subperfect'
            :riskLevel === 3 ? 'lowrisk'
            : 'heighrisk'
        ]">
          <div class="rank js_worldofwar">
            <p class="resultTit">企业安全风险评测结果</p>
            <span class="resultSubTit">-&nbsp;评测得分依据您企业真实性评测综合分析判定&nbsp;-</span>
            <div class="resultNumbArea">
              <p class="tit">安全评测</p>
              <p class="Numb">
                <span>{{ datalist.totalScoreAndRankData.totalScore || newUserResult.total_score }}</span>分
              </p>
              <span class="ranklevel" v-if="riskLevel !== 1 && riskLevel !== 2"><i
                  class="wranning">!</i>{{ datalist.riskevalAvgScoreHierarchy.name || newUserResultLevel}}企业</span>
              <span class="ranklevel"
                v-else-if="riskLevel === 2 ">{{ datalist.riskevalAvgScoreHierarchy.name || newUserResultLevel}}企业</span>
              <span class="ranklevel" v-else>{{ datalist.riskevalAvgScoreHierarchy.name || newUserResultLevel}}</span>
            </div>
            <div class="companyTestRank">
              <div class="companyRank" v-if="riskLevel !== 1 && riskLevel !== 2">
                <div class="leftRank">
                  <img crossorigin="anonymous" src='./images/flag.png'
                    style="width: 89%;height: 53px; position:absolute;top:27px">
                  <div class="flag">
                    <div class="centerbox">
                      <div class="fire"></div>
                      <div class="rightbox">
                        <p class="AnimateNum " :data-num="
                        datalist.totalScoreAndRankData.hiddenDangerRank
                      ">
                          {{datalist.totalScoreAndRankData.hiddenDangerRank }}
                        </p>
                        <p>企业隐患排名</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rightRank">
                  <div class="medal"></div>
                  <div class="TotalRank">
                    <p class="AnimateNum" :data-num="datalist.totalScoreAndRankData.riskUserRank">
                      {{ datalist.totalScoreAndRankData.riskUserRank }}
                    </p>
                    <p>企业总排名</p>
                  </div>
                </div>

              </div>
              <div class="companyRank" v-else-if="riskLevel === 2">
                <div class="leftRank">
                  <div class="flag">
                    <div class="centerbox">
                      <div class="fire"></div>
                      <div class="rightbox">
                        <p class="AnimateNum " :data-num="
                        datalist.totalScoreAndRankData.hiddenDangerRank
                      ">
                          {{datalist.totalScoreAndRankData.hiddenDangerRank }}
                        </p>
                        <p>企业隐患排名</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rightRank">
                  <div class="medal"></div>
                  <div class="TotalRank">
                    <p class="AnimateNum" :data-num="datalist.totalScoreAndRankData.riskUserRank">
                      {{ datalist.totalScoreAndRankData.riskUserRank }}
                    </p>
                    <p>企业总排名</p>
                  </div>
                </div>
              </div>
              <div class="companyRank" v-else>
                <div class="medal"></div>
                <div class="TotalRank">
                  <p class="AnimatePerNum" :data-num="datalist.totalScoreAndRankData.riskUserRank">
                    {{"NO." + datalist.totalScoreAndRankData.riskUserRank }}
                  </p>
                  <p>企业总排名</p>
                </div>
              </div>
              <div class="averageRank">
                <div class="leftPart">
                  <p class="AnimateNum"
                    :data-num="datalist.totalScoreAndRankData.industryAvgScoreData.industryAvgScore">
                    {{
                    datalist.totalScoreAndRankData.industryAvgScoreData.industryAvgScore
                  }}
                  </p>
                  <span>{{
                  datalist.totalScoreAndRankData.industryAvgScoreData.totalIndustryRank
                }}</span>
                  <p>同行业平均分</p>
                </div>
                <div class="rightPart">
                  <p class="AnimateNum" :data-num="datalist.totalScoreAndRankData.areaAvgScoreData.areaAvgScore">
                    {{
                    datalist.totalScoreAndRankData.areaAvgScoreData.areaAvgScore
                  }}
                  </p>
                  <span>{{
                  datalist.totalScoreAndRankData.areaAvgScoreData.areaRank
                }}</span>
                  <p>同区域平均分</p>
                </div>
              </div>
              <div class="sameIndustryRank">同行业评测排名</div>
              <div class="sameIndustry" ref="sameIndustry" id="chart-part1"></div>
              <div class="sameAreaRank">同区域评测排名</div>
              <div class="sameArea" ref="sameArea" id="chart-part2"></div>
            </div>
          </div>
          <div class="probability clearfix js_worldofwar">
            <div v-if="riskLevel !== 1">
              <div v-if="companyRiskFlag === true">
                <div class="circle" ref="circle" id="chart-part3"></div>
                <div class="CircleToTalNumb">{{TotalNum}}<span v-if='StringFlag'
                    class="CircleToTalPoint">{{'.'+Tp+'%'}}</span><span v-else>%</span></div>
                <div class="centerRowbox">
                  <div class="rowScroll">
                    <div class="leftBox" ref="leftcircle" id="chart-part4">
                      <p class="innerP" v-if="riskevalDeviceFlag === false">暂无隐患</p>
                    </div>
                    <div class="rightBox">
                      <div class="inner" ref="rightcircle" id="chart-part5">
                        <p class="innerP" v-if="riskevalSystemFlag === false">暂无隐患</p>
                      </div>
                    </div>
                  </div>
                </div>
                <ul class="radioTab">
                  <li :class=" activeFlag === true ? 'active':''"></li>
                  <li :class=" activeFlag === false ? 'active':''"></li>
                </ul>
              </div>
              <div v-else-if="companyRiskFlag === false">
                <div class="icon"></div>
                <p>目前您的企业安全防范措施<span>非常不错</span> ，请再接再厉！</p>
                <div class="centerRowbox">
                  <div class="rowScroll">
                    <div class="leftBox" ref="leftcircle" id="chart-part4">
                      <p class="innerP" v-if="riskevalDeviceFlag === false">暂无隐患</p>
                    </div>
                    <div class="rightBox">
                      <div class="inner" ref="rightcircle" id="chart-part5">
                        <p class="innerP" v-if="riskevalSystemFlag === false">暂无隐患</p>
                      </div>
                    </div>
                  </div>
                </div>
                <ul class="radioTab">
                  <li :class=" activeFlag === true ? 'active':''"></li>
                  <li :class=" activeFlag === false ? 'active':''"></li>
                </ul>
              </div>

            </div>
            <div v-else>
              <div class="icon"></div>
              <p>目前您的企业安全防范措施<span>非常不错</span> ，请再接再厉！</p>
            </div>
          </div>
          <div class="reality js_worldofwar">
            <div v-show='boxshow === index' class="centerBox" v-for="(item, index) in datalist.deviceOut" :key="index">
              <ul class="tab">
                <li :class="[index === idx ? 'active' : '']" v-for="(elem, idx) in datalist.deviceOut" :key="idx"
                  @click="changeView(idx)">
                  {{ elem.name }}
                </li>
                <li class="blank" v-show="datalist.deviceOut.length <= 1"></li>
                <!-- <li class="active" @click="changeTab(1)">提炼加工厂</li>
              <li @click="changeTab(2)">停车场</li> -->
              </ul>
              <div class="rollBlock">
                <!-- <div class="rollarea" @mouseenter="showArrow" @mouseleave="hideArrow"> -->
                <div class="rollarea">
                  <!-- <div v-show="mouseIn === true && atLeft === false" class="leftArrow" @click="handleleftScroll(index)"></div> -->
                  <!-- <div v-show="mouseIn === true && atRight === false && NewArr[index].length > 1" class="rightArrow" @click="handlerightScroll(index)"></div> -->
                  <div class="EchartsArea">
                    <div class="scroll" :data-type="index">
                      <div v-show="it.siteUserDeviceList[0].device_name !== '都没有' && it.siteUserDeviceList.length >= 1"
                        class="packageBox" v-for="(it, x) in item.chartDeviceList" :key="x">
                        <p class="title">
                          {{ it.siteName+"("+it.deviceTypeStr+")" }}
                        </p>
                        <div class="echart" ref="echart"></div>
                        <!-- <div class="echartone" ref="echartone" id="chart-part6"></div> v-show="it.siteUserDeviceList[0].device_name !== '都没有' && it.siteUserDeviceList.length >= 1"
                    <div class="echarttwo" ref="echarttwo" id="chart-part7"></div>
                    <div class="echartthree" ref="echartthree" id="chart-part8"></div> -->
                      </div>
                    </div>
                  </div>
                  <ul class="radio">
                    <li v-show="NewArr[index].length > 1" :class="['rollLi', liconter === i ? 'active' : '']"
                      v-for="(el, i) in NewArr[index]" :key="i"></li>
                  </ul>

                  <!-- <li></li>
                  <li></li> -->
                </div>
                <div v-if="riskLevel !== 1">
                  <div class="warningArea">
                    <i class="Warnning">!</i>
                    <p>本单位未按照《消防法》相关规定落实消防安全工作，请立即整改，如后续抽查不合格，将面临停业整改，并可处最高三十万元罚款；</p>
                  </div>
                  <div class="realityDetail">
                    <p class="detailTitle">
                      结合您企业的实际情况、参考国家消防规范
                    </p>
                    <a href="http://cdn.zxzx119.com/44565756745456546.pdf" target="_blank">《中华人民共和国消防法》</a>
                    <font style="fontSize:12px;color:#0EEBFF">、</font>
                    <a href="http://cdn.zxzx119.com/15645324534656545.pdf" target="_blank">《自动喷火灭火设计规范》GB 50084-2017</a>
                    <font style="fontSize:12px;color:#0EEBFF">、</font>
                    <a href="http://cdn.zxzx119.com/234546754643.pdf" target="_blank">《建筑灭火器配置设计规范》GB 50140-2005</a>
                    <font style="fontSize:12px;color:#0EEBFF">、</font>
                    <a href="http://cdn.zxzx119.com/334654756875.pdf" target="_blank">《火灾探测器（烟感温感）设置与安装规范》</a>
                    <p v-show="siteUserDeviceListFlag[index]" class="detailTitle">{{item.name}}缺失的设施设备：</p>
                    <span v-show="siteUserDeviceListFlag[index]" v-for="(val,ie) in item.siteUserDeviceList"
                      :key="ie+1">
                      <span v-if=" val.norm_number - val.real_number > 0"
                        class="txt">{{ie+1}}.{{val.device_name}}：应至少再增加<span
                          class="num">{{ val.norm_number - val.real_number }}</span>个</span>
                    </span>
                    <p v-show="Canshow[index]" class="detailTitle sub" style="font-weight:normal">
                      {{item.name}}内所有场地应配置设施设备明细<span class="detailSpride" @click="showOrhide">【{{ DeatilMsg }}】</span>
                    </p>
                    <div v-show="showDetail && Canshow[index]" class="content">
                      <div class="contentItem" v-for="(it, ix) in item.subList" :key="ix">
                        <p class="detailTitle" v-if='it.siteUserDeviceList.length > 0'>{{it.name}}：</p>
                        <div class="singleline" v-for="(value,indx) in it.siteUserDeviceList" :key="indx+1">
                          <span v-if="value.norm_number - value.real_number > 0"><span
                              class="underLine">{{value.device_name}}</span><span class="txt">：应至少再增加<span
                                class="num">{{ value.norm_number - value.real_number }}</span>个</span></span>
                          <!-- <span v-else><span class="txt">无隐患</span></span> -->
                        </div>
                      </div>
                    </div>
                    <p v-if="systemFlag" class="detailTitle">目前缺失的物联网系统：</p>
                    <div v-if="systemFlag" class="systemlack">
                      <!-- <div class="system" v-show="em.name === judgeArr[index][iex]" v-for="(em, iex) in iconBox" :key="iex"> -->
                      <div class="system" v-show="em.show" v-for="(em, iex) in judgeArr[index]" :key="iex">
                        <img :src="em.img" />
                        <p>{{ em.name }}</p>
                      </div>
                    </div>
                    <!-- <div v-if="itemvalue.age <= 1"> -->
                    <p v-if="showDeviceFlag[index]" class="detailTitle">{{item.name}}房屋老化维护保养：</p>
                    <div style="display:inline-block">
                      <span v-for="(itemvalue, indexvalue) in item.siteAgeList" :key="indexvalue"
                        v-show="itemvalue.age>5" class="txtbox">{{ itemvalue.siteName }}：<span
                          class="num">{{ itemvalue.age }}年</span></span>
                    </div>
                    <div v-for="(ageText,ageIndex) in item.ageContentList" :key="ageIndex">
                      <p v-html="ageText" class="text">
                        {{ ageText }}
                      </p>
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <!-- </div> -->
            </div>
          </div>
          <div class="answer js_worldofwar" v-if="riskLevel !== 1 && datalist.repairList.length > 0 ">
            <div class="textcontent">
              <div class="Forcircle" v-for="(elmitem, elmindex) in datalist.repairList" :key="elmindex">
                <p class="answerTitle">{{ elmitem.group_name }}</p>

                <div style="text-align:left;font-size: 12px;color: #ffffff;" v-for="(v,k) in splitArr[elmindex]"
                  :key="k">
                  {{k+1}}、<span v-html="v" class="answertext">{{v}}</span>
                  <!-- <p v-html="it" class="answertext" v-for="(it,ud) in v" :key="ud">
                    {{it}}
                  </p> -->
                </div>
              </div>
            </div>
            <div class="warningArea">
              <i class="Warnning">!</i>
              <p>本单位未按照《消防法》相关规定落实消防安全工作，请立即整改，如后续抽查不合格，将面临停业整改，并可处最高三十万元罚款；</p>
            </div>
          </div>
          <!-- <div class="blankArea" id="blankArea"></div> -->
        </div>
        <!-- <div id="fxpay" style="position: absolute;width: 700px;background-color: white;top: calc(45% - 250px);left:0;right:0;margin: 0 auto; z-index: 550"> -->
        <div class="mark-view" v-show="!fxcp">
          <div class="content">依据&nbsp;<span>大数据精准</span>&nbsp;分析，<br /><span>360°</span><span
              class="bold">提升</span>&nbsp;企业抗风险能力</div>
          <div class="lookBtn" @click="lookResultClick">获取报告</div>
        </div>
        <!-- <div v-show="!fxcp" class="maskshow"></div> -->
      </div>

      <el-dialog title="温馨提示" :visible.sync="dialogTableVisible" width="80%" top="25vh">
        <!-- <el-dialog title="温馨提示"  width="30%"> -->
        <p style="text-align: center;font-size:14px;lineHeight:14px;height:14px">您有<span
            style="color: #c41335">{{dd}}</span>个整改的消防设施订单未付款</p>
        <div style="display: flex;justify-content: center;margin-top: 40px;">
          <div
            style="text-align: center;width: 98px;height: 40px;border:1px solid #c41335;border-radius:4px;line-height: 40px;font-size: 14px;color: #c41335;cursor: pointer;margin-right: 40px;"
            @click="dialogTableVisible=false">取消整改</div>
          <div
            style="text-align: center;width: 98px;height: 40px;background:#c41335;border:1px solid #c41335;border-radius:4px;line-height: 40px;font-size: 14px;color: #ffffff;cursor: pointer;"
            @click="qwzg">前往整改</div>
        </div>
      </el-dialog>
    </div>
    <div class="bottombuttons">
      <div class="inner">
        <div class="buttonBox">
          <span class="export" @click="exportPdf">导出报告</span>
          <span @click="bugsp()" class="OneKeyDeal" v-if="wantbuy&&yjjj">一键解决</span>
          <span @click="bugcg()" class="OneKeyDeal" v-if="!yjjj">一键采购</span>
        </div>
      </div>
    </div>
    <payView type="3" :show="payViewVisible" @payValue="payValue"></payView>
    <AlertView :show="showAlert" title="" :subTitle="alerViewTitle" cancelTitle="取消" :sureTitle="alertSureTitle"
      @alertViewClick="alertViewClick"></AlertView>
    <div class="changeBrowser" v-show="changeBrowser">
      <div class="alertBody">
        <h1>温馨提示</h1>
        <p>当前浏览器不支持此功能<br>请更换其他浏览器使用</p>
        <span @click="changeBro">我知道了</span>
      </div>
    </div>
  </div>
</template>
<script>
import evaluatorHeader from '../../view/evaluator-header'
import echarts from 'echarts'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import payView from '../../components/pay'
import AlertView from '../../components/alert-view'
import { Toast, Indicator } from 'mint-ui'
import axios from 'axios'
// import htmlToPdf from "./htmlToPdf";
export default {
  // name: "fxcp",
  components: {
    evaluatorHeader,
    VueQrcode,
    payView,
    AlertView
  },
  data () {
    return {
      dd: 0,
      Tp: '',
      TotalNum: '',
      fxcp: true,
      xfssshow: false,
      wantbuy: true,
      activeFlag: true,
      showAlert: false,
      changeBrowser: false,
      alerViewTitle: '',
      alertSureTitle: '',
      ViewTitle: '',
      SureTitle: '',
      changetk: false,
      getResultId: null,
      payViewVisible: false,
      StringFlag: false,
      ReloadFlag: null,
      numjj: 0,
      yjjj: true,
      boxshow: 0,
      tkshow: false,
      systemFlag: false,
      showDetail: true,
      showDeviceFlag: [],
      siteUserDeviceListFlag: [],
      companyRiskFlag: true,
      riskevalDeviceFlag: true,
      riskevalSystemFlag: true,
      showFlag: 1,
      Canshow: [],
      DeatilMsg: '点击收起',
      dialogTableVisible: false,
      splitArr: [],
      headershow: true,
      TopHeight: null,
      elmArr: [],
      shopzzList: [],
      shopqqList: [],
      judgeList: [],
      animation: null,
      reloadFlag: null,
      msg: '',
      mouseIn: false,
      siteAgeFlag: [],
      // sitAgeFlagList: [],
      atLeft: true,
      atRight: false,
      scrollItemlength: null,
      payInfoUrl: '/item/order/',
      remittanceUrl: '/zxOrder/update/',
      payUrl: '/newPay/',
      payStatusUrl: '/pay/status/',
      payStatus: '',
      cdnUrl: 'http://cdn.zxzx119.com',
      liconter: 0,
      iconBox: [
        {
          img: require('./images/icon1.png'),
          name: '火灾自动报警系统',
          show: false
        },
        {
          img: require('./images/icon2.png'),
          name: '水监控系统',
          show: false
        },
        {
          img: require('./images/icon3.png'),
          name: '电流电压监控系统',
          show: false
        },
        {
          img: require('./images/icon4.png'),
          name: '视频监控系统',
          show: false
        },
        {
          img: require('./images/icon5.png'),
          name: '排风控制系统',
          show: false
        },
        {
          img: require('./images/icon6.png'),
          name: '防烟排烟系统',
          show: false
        },
        {
          img: require('./images/icon7.png'),
          name: '风系统',
          show: false
        },
        {
          img: require('./images/icon8.png'),
          name: '可燃气体监控系统',
          show: false
        },
        {
          img: require('./images/icon9.png'),
          name: '自动喷淋系统',
          show: false
        }
      ],
      datalist: {
        riskevalAvgScoreHierarchy: {
          name: ''
        },
        totalScoreAndRankData: {
          totalScore: null,
          riskUserRank: null,
          hiddenDangerRank: null,
          industryAvgScoreData: {
            industryAvgDetails: [
              {
                avgScore: 27,
                maxScore: 41,
                siteName: '仓储场所'
              }
            ],
            industryAvgScore: null,
            totalIndustryRank: null
          },
          areaAvgScoreData: {
            areaAvgScore: 33,
            areaRank: 4,
            areaRankDetail: {
              maxScore: 100,
              avgScore: 30,
              areaName: '黄浦区'
            }
          }
        },
        companyRiskevalProbability: {
          riskevalDeviceName: '物防措施',
          riskevalDeviceProbability: '6.16%',
          riskevalHouseName: '房龄老化',
          riskevalHouseProbability: '4.4%',
          riskevalSafetyName: '安全意识',
          riskevalSafetyProbability: '18.0%',
          riskevalSystemName: '技防措施',
          riskevalSystemProbability: '10.0%',
          riskevalWindName: '风控措施',
          riskevalWindProbability: '8.0%',
          riskevalWithoutName: '无隐患',
          riskevalWithoutProbability: '53.44%'
        },
        deviceRiskevalProbabilityList: [
          {
            deivceProbability: '0.88%',
            deviceName: '室外消火栓'
          }
        ],
        systemRiskevalProbabilityOuts: [
          {
            systemName: '排风监控系统',
            systemProbability: '0.0%'
          }
        ],
        deviceOut: [
          {
            ageContent: '',
            ageContentList: [],
            chartDeviceList: [
              {
                deviceType: 2,
                deviceTypeStr: '室外',
                siteName: '提炼加工厂',
                siteUserDeviceList: [
                  {
                    created_time: '2019-12-04 11:05:16',
                    device_name: '手提式灭火器',
                    device_type: 3,
                    id: 19223,
                    norm_number: 0,
                    real_number: 12,
                    result_id: 2761,
                    site_category_id: 235,
                    tails: {}
                  }
                ]
              }
            ],
            siteAgeList: [
              {
                age: 22,
                siteName: '纺织品库房'
              }
            ],
            systemList: [
              {
                createtime: '2019-11-21 15:44:51',
                id: 3,
                score: 2,
                system_name: '视频监控系统'
              }
            ]
          }
        ],
        repairList: [
          {
            group_name: '安全意识',
            id: 1,
            repair_content:
              '保证人生财产安全，防止安全事故的发生，应做到"检查消除火灾隐患的能力、组织扑救初起火灾的能力、组织人员疏散逃生的能力、消防宣传教育培训的能力"；zxzx2019保证人生财产安全，防止安全事故的发生，应做到"懂得自身岗位的火灾危害、懂火灾的扑救方法、懂预防火灾的措施"；zxzx2019为了更好地提高人们的安全防范意识、普及火灾逃生常识，做好防火救灾、减少甚至消除恶性事故发生，企业要定期组织每年实践演练一次；zxzx2019企业应当至少每月进行一次<a style="color: #c41335;text-decoration: underline;" target="_blank" href="http://192.168.110.234:5060/safetrain">防火隐患排查</a>，消除遗留火种；'
          }
        ]
      },
      riskLevel: '',
      echartDataArr: [],
      echartDataList: [],
      echartList: [],
      newUserResult: [],
      newUserResultLevel: '',
      list: [
        { money: '', type: '', count: '', mon_each: '' },
        { money: '', type: '', count: '', mon_each: '' },
        { money: '', type: '', count: '', mon_each: '' }
      ],
      score: '',
      money: '',
      payType: '',
      qrCode: '',
      item: {},
      ind: 2,
      onceOrder: 0,
      NewArr: [],
      judgeArr: [],
      partArr: []
    }
  },
  mounted () {
    window.pageYOffset = 0
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    window.addEventListener('scroll', this.handleScroll, true)
    // window.addEventListener('centerRowbox', this.handleRowScroll, true)
    this.getData()
    window.onorientationchange = this.backAndChange
    this.$nextTick(() => {
      setTimeout(() => {
        let echartScroll = document.getElementsByClassName('EchartsArea')
        echartScroll[0].addEventListener(
          'scroll',
          this.handleEchartRowScroll,
          true
        )
        let scrollItem = document.querySelector('.centerRowbox')
        scrollItem.addEventListener('scroll', this.handleRowScroll, true)
        this.handleScroll()
        this.scrollItemlength = document.getElementsByClassName(
          'packageBox'
        ).length
      }, 200)
      // this.loadOrderState()
    })
  },
  destroyed: function () {
    window.onorientationchange = ''
  },
  methods: {
    lookResultClick: function () {
      // 查看 报告 支付
      this.payViewVisible = true
    },

    forbideScroll (e) {
      e.preventDefault()
    },

    // 固定页面，禁止滚动
    bindScroll () {
      document.body.style.overflow = 'hidden'// 禁止滚动
      document.addEventListener('touchmove', this.forbideScroll, false) // 先加上，后面再清
    },

    // 恢复滚动
    startScroll () {
      document.body.style.overflow = 'auto'// 出现滚动条
      document.removeEventListener('touchmove', this.forbideScroll, false)
    },

    exportPdf () {
      // 判断浏览器.indexOf(' qq') > -1
      let browser = window.navigator.userAgent
      if (browser.indexOf('MQQBrowser') > -1 || browser.toLocaleLowerCase().indexOf(' qq') > -1) {
        this.changeBrowser = true
        document.body.style.overflow = 'hidden'
        // this.ViewTitle = '当前浏览器不支持此功能，请更换浏览器使用'
        // this.SureTitle = '我知道了'
      } else {
        window.pageYOffset = 0
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
        document.body.style.position = 'fixed'
        document.body.style.top = '0'
        document.body.style.width = 100 + '%'
        this.bindScroll()
        if (document.getElementsByClassName('text').length > 0) {
          let child = document.getElementsByClassName('text')
          for (let i = 0; i < child.length; i++) {
            let childA = child[i].children
            for (let j = 0; j < childA.length; j++) {
              childA[j].classList.add('noline')
            }
          }
        }
        if (document.getElementsByClassName('answertext').length > 0) {
          let anwserTxt = document.getElementsByClassName('answertext')
          for (let m = 0; m < anwserTxt.length; m++) {
            let childA = anwserTxt[m].children
            for (let n = 0; n < childA.length; n++) {
              childA[n].classList.add('noline')
            }
          }
        }
        setTimeout(() => {
          this.canvasHtml(this.datalist.entName + '_风险测评报告.jpg')
        }, 2000)
      }
    },

    canvasHtml: function (reportname) {
      Indicator.open({
        spinnerType: 'fading-circle'
      })
      let _this = this
      setTimeout(function () {
        let image = document.getElementById('cssMainBody')
        var w = image.offsetWidth
        var h = image.offsetHeight
        // 将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
        var scale = 2
        var canvas = document.createElement('canvas')
        canvas.width = w * scale
        canvas.height = h * scale
        canvas.getContext('2d').scale(scale, scale)

        var options = {
          scale: 2,
          useCORS: true, // 貌似与跨域有关，但和allowTaint不能共存
          background: '#FFFFFF'
        }
        _this.html2canvas(image, options).then(function (canvas) {
          let imageUrl = canvas.toDataURL('image/png')
          let file = _this.dataURLtoFile(imageUrl, reportname)
          Indicator.close()
          _this.startScroll()
          document.body.style.position = 'relative'
          document.body.style.top = '0'
          _this.uploadImage(file)
        })
      }, 300)
    },
    dataURLtoFile: function (dataurl, filename) { // 将base64转换为文件
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    uploadImage: function (image) {
      this.utils.uploadReportImage(image, function (response) {
        let href = 'http://cdn.zxzx119.com/' + response
        // 此时恢复之前样式
        if (document.getElementsByClassName('text').length > 0) {
          let child = document.getElementsByClassName('text')
          for (let i = 0; i < child.length; i++) {
            let childA = child[i].children
            for (let j = 0; j < childA.length; j++) {
              childA[j].classList.remove('noline')
            }
          }
        }
        if (document.getElementsByClassName('answertext').length > 0) {
          let anwserTxt = document.getElementsByClassName('answertext')
          for (let m = 0; m < anwserTxt.length; m++) {
            let childA = anwserTxt[m].children
            for (let n = 0; n < childA.length; n++) {
              childA[n].classList.remove('noline')
            }
          }
        }
        window.location.href = href
      })
    },

    alertViewClick: function (index) {
      this.showAlert = false
      if (index === 1) {
        window.location.href = this.pcOrderList
      }
    },
    changeBro () {
      this.changeBrowser = false
      document.body.style.overflow = 'auto'
    },
    payValue: function (state) {
      console.log('============支付回调')
      this.payViewVisible = false
      if (state === 1) {
        // 支付成功
        this.reload()
      }
    },
    logoutClick: function () {
      // 退出登录
      this.$router.push({ path: 'home' })
    },
    qwzg () {
      window.location.href = this.pcOrderList
    },
    initNumb () {
      let NumElem = document.querySelectorAll('.AnimateNum')
      let speed = 10
      NumElem.forEach((item, index) => {
        let goal = item.getAttribute('data-num')
        let i = 0 // 累加器
        let Timmer = setInterval(() => {
          if (i < goal) {
            i = i + Math.ceil(goal / speed)
            item.innerHTML = i
          } else if ((i = goal)) {
            item.innerHTML = i
            clearInterval(Timmer)
          } else {
            clearInterval(Timmer)
          }
        }, 100)
      })
    },
    // 初始化所有需要滚动的组件
    // initRoll () {
    //   let RollElem = document.querySelectorAll('.js_worldofwar')
    //   RollElem.forEach(item => {
    //     item.setAttribute('data-offsetTop', item.offsetTop)
    //     this.elmArr.push(item)
    //     item.classList.remove('js_worldofwar')
    //   })
    //   return new Promise((resolve, reject) => {
    //     resolve()
    //   })
    // },
    // 初始化动画
    // initAnimate () {
    //   this.initRoll().then(() => {
    //     this.handleScroll()
    //   })
    // },

    changeView (i) {
      let echartScroll = document.getElementsByClassName('EchartsArea')
      echartScroll[i].addEventListener(
        'scroll',
        this.handleEchartRowScroll,
        true
      )
      this.boxshow = i
      this.liconter = 0
      if (this.NewArr[i].length <= 1) {
        this.atLeft = true
        this.atRight = true
      } else {
        this.atLeft = true
        this.atRight = false
      }
      setTimeout(() => {
        document.getElementsByClassName('scroll')[i].scrollLeft = 0
      }, 100)
    },

    handleScroll (isRemove) {
      this.TopHeight =
        document.documentElement.clientHeight +
        document.documentElement.scrollTop
      let elemData
      if (isRemove !== 1) {
        for (let i = 0, elem; i < this.elmArr.length; i++) {
          elem = this.elmArr[i]
          elemData = elem.getAttribute('data-offsetTop')
          if (elemData <= this.TopHeight) {
            elem.classList.add('js_worldofwar')
            this.elmArr.splice(i, 1)
            --i
          }
        }
      } else {
        for (let i = 0, elem; i < this.elmArr.length; i++) {
          elem = this.elmArr[i]
          elemData = elem.getAttribute('data-offsetTop')
          if (elemData >= this.TopHeight) {
            elem.classList.remove('js_worldofwar')
          } else {
            elem.classList.add('js_worldofwar')
          }
        }
      }
    },

    getData () {
      // if (this.$route.query.result_id != null) {
      this.getResultId =
        this.$route.query.result_id || this.$route.query.resultId
      this.utils.GET(
        this.accountUrl +
        '/riskevalNew/getNewResultById?resultId=' +
        this.getResultId,
        res => {
          if (res.code === 50004) {
            this.dealLevel(res.data.scoreRank)
            this.newUserResultLevel = res.data.scoreRank
            document.documentElement.scrollTop = document.body.scrollTop = 0
            this.fxcp = false
            document.body.classList.add('fixedClass')
            // let Html = document.getElementsByTagName('html')
            // Html[0].style.overflow = 'hidden'
            this.newUserResult = res.data.newUserResult
          } else {
            this.fxcp = true
            document.body.classList.remove('fixedClass')
            // let Html = document.getElementsByTagName('html')
            // Html[0].style.overflow = 'auto'
            // document.body.style.overflow = 'auto'
            // this.newUserResult = resj.data.newUserResult;
            this.datalist = res.data
            this.dealLevel(this.datalist.riskevalAvgScoreHierarchy.name)
            setTimeout(() => {
              this.datalist.deviceOut.forEach((item, index) => {
                if (item.subList.length > 0) {
                  // this.Canshow = true
                  item.subList.forEach((n, m) => {
                    let arrcont = 0
                    n.siteUserDeviceList.forEach((v, i) => {
                      if (v.norm_number - v.real_number > 0) {
                        arrcont++
                      }
                    })
                    if (arrcont <= n.siteUserDeviceList.length && arrcont > 0) {
                      this.Canshow[index] = true
                    } else {
                      this.Canshow[index] = false
                    }
                  })
                } else {
                  this.Canshow[index] = false
                }
                if (item.siteUserDeviceList.length > 0) {
                  this.siteUserDeviceListFlag[index] = true
                } else {
                  this.siteUserDeviceListFlag[index] = false
                }
                let siteList = item.siteAgeList
                // let sitAgeFlagList = []
                let AgeCont = 0
                siteList.forEach((m, n) => {
                  if (m.age < 6) {
                    AgeCont++
                  }
                })
                if (AgeCont === siteList.length && AgeCont !== 0) {
                  this.showDeviceFlag[index] = false
                } else {
                  this.showDeviceFlag[index] = true
                }

                item.chartDeviceList.forEach((v, k) => {
                  let Arr = []
                  v.siteUserDeviceList.forEach((ele, p) => {
                    if (v.siteUserDeviceList.length <= 1 && v.siteUserDeviceList[0].device_name === '都没有') {
                      // conter++
                    } else {
                      Arr.push(ele)
                    }
                  })
                  if (Arr.length !== 0) {
                    this.echartDataArr.push(Arr)
                  }
                })
              })
              if (parseFloat(this.datalist.companyRiskevalProbability.riskevalDeviceProbability) === 0 &&
                parseFloat(this.datalist.companyRiskevalProbability.riskevalHouseProbability) === 0 &&
                parseFloat(this.datalist.companyRiskevalProbability.riskevalPersonProbability) === 0 &&
                parseFloat(this.datalist.companyRiskevalProbability.riskevalSafetyProbability) === 0 &&
                parseFloat(this.datalist.companyRiskevalProbability.riskevalSystemProbability) === 0 &&
                parseFloat(this.datalist.companyRiskevalProbability.riskevalWindProbability) === 0 &&
                parseFloat(this.datalist.companyRiskevalProbability.riskevalWithoutProbability) === 100
              ) {
                this.companyRiskFlag = false
              } else {
                this.companyRiskFlag = true
              }

              if (parseFloat(this.datalist.companyRiskevalProbability.riskevalDeviceProbability) === 0) {
                this.riskevalDeviceFlag = false
              } else {
                this.riskevalDeviceFlag = true
              }

              if (parseFloat(this.datalist.companyRiskevalProbability.riskevalSystemProbability) === 0) {
                this.riskevalSystemFlag = false
              } else {
                this.riskevalSystemFlag = true
              }

              this.datalist.deviceOut.forEach((item, index) => {
                let arrCont = 0
                item.chartDeviceList.forEach((v, k) => {
                  arrCont++
                })
                this.NewArr.push(this.echartDataArr.slice(0, arrCont))
              })

              this.datalist.repairList.forEach((item, index) => {
                let splicStr = item.repair_content.split('zxzx2019')
                this.splitArr.push(splicStr)
              })
              this.datalist.deviceOut.forEach((item, index) => {
                let outArr = []
                if (item.systemList.length > 0) {
                  this.systemFlag = true
                  item.systemList.forEach((val, key) => {
                    for (let i = 0; i < this.iconBox.length; i++) {
                      if (val.system_name === this.iconBox[i].name) {
                        this.iconBox[i].show = true
                        outArr.push(this.iconBox[i])
                      }
                    }
                  })
                } else {
                  this.systemFlag = false
                }
                this.judgeArr.push(outArr)
                // let partly = [];
              })

              if (this.datalist.deviceGoodsList.length == 0) {
                this.wantbuy = false
              }
              this.shopqqList = this.datalist.deviceGoodsList
              this.shopqqList.forEach((item, index) => {
                if (item.req_number - item.commit_number < 1) {
                  this.numjj++
                }
              })
              this.ztcx()
              this.initNumb()
              this.getEcharts()
            }, 100)
          }
        }
      )

      // window.location.reload()
    },

    backAndChange () {
      let reload = localStorage.getItem('judgeReload')
      if (window.orientation === 180 || window.orientation === 0) {
        if (reload !== 'true') {
          localStorage.setItem('judgeReload', 'true')
          window.location.reload()
        }
      }
      if (window.orientation === 90 || window.orientation === -90) {
        if (reload === 'true' || reload === null) {
          localStorage.setItem('judgeReload', 'false')
          window.location.reload()
        }
      }
    },

    change (i) {
      this.ind = i
      this.item = this.list[i]
      this.getPay()
    },

    dealLevel (String) {
      switch (String) {
        case '超高危':
          this.riskLevel = 4
          break
        case '高危':
          this.riskLevel = 4
          break
        case '中危':
          this.riskLevel = 3
          break
        case '低危':
          this.riskLevel = 2
          break
        case '完美':
          this.riskLevel = 1
          break
        default:
          break
      }
    },
    handleRowScroll () {
      let body = document.getElementsByClassName('centerRowbox')
      let bodyLeft = body[0].scrollLeft
      if (bodyLeft > 240) {
        this.activeFlag = false
      } else {
        this.activeFlag = true
      }
    },
    handleEchartRowScroll () {
      let Scrollbody = document.getElementsByClassName('scroll')
      let MarkNum = Scrollbody[this.boxshow].getAttribute('data-type')
      let RowBoxLength = this.NewArr[MarkNum].length
      let ScrollbodyLeft = Scrollbody[this.boxshow].scrollLeft
      if (window.orientation === 180 || window.orientation === 0) {
        if (Math.ceil(ScrollbodyLeft / 300) <= RowBoxLength) {
          this.liconter = Math.ceil(ScrollbodyLeft / 300) - 1
        }
        if (parseInt(ScrollbodyLeft / 300) === 0) {
          this.liconter = 0
        }
      }
      if (window.orientation === 90 || window.orientation === -90) {
        if (Math.ceil(ScrollbodyLeft / 600) <= RowBoxLength) {
          this.liconter = Math.ceil(ScrollbodyLeft / 600) - 1
        }
        if (parseInt(ScrollbodyLeft / 600) === 0) {
          this.liconter = 0
        }
      }
    },
    showOrhide () {
      if (this.showFlag === 0) {
        this.showDetail = true
        this.showFlag = 1
        this.DeatilMsg = '点击收起'
      } else {
        this.showDetail = false
        this.showFlag = 0
        this.DeatilMsg = '点击展开'
      }
    },

    floatAdd (num1, num2) {
      let r1, r2, m
      try {
        r1 = num1.toString().split('.')[1].length
      } catch (e) {
        r1 = 0
      }
      try {
        r2 = num2.toString().split('.')[1].length
      } catch (e) {
        r2 = 0
      }
      m = Math.pow(10, Math.max(r1, r2))
      return Math.round(num1 * m + num2 * m) / m
    },

    getEcharts () {
      const sameIndustry = this.$refs.sameIndustry
      const sameArea = this.$refs.sameArea
      const circle = this.$refs.circle
      const leftcircle = this.$refs.leftcircle
      const rightcircle = this.$refs.rightcircle
      this.echartList = document.querySelectorAll('.echart')
      // sameIndustry.removeAttribute('_echarts_instance_')
      // sameArea.removeAttribute('_echarts_instance_')
      // circle.removeAttribute('_echarts_instance_')
      // leftcircle.removeAttribute('_echarts_instance_')
      // rightcircle.removeAttribute('_echarts_instance_')
      // for (let e = 0; e < this.echartList.length; e++) {
      //   this.echartList[e].removeAttribute('_echarts_instance_')
      // }
      if (sameIndustry) {
        let myChart = this.echarts.init(
          // document.getElementById("chart-part1")
          this.$refs.sameIndustry
        )
        // let xdata = [
        //   "工厂  " + "  企业",
        //   "仓储场所  " + "企业",
        //   "店铺  " + "  企业"
        // ];
        let legendData = ['同行业', '企业']
        // let dataArr = [20, 12, 31];
        // let dataArr2 = [10, 10, 10];
        let xdata = []
        // let legendData = []
        let dataArr = []
        let dataArr2 = []
        this.datalist.totalScoreAndRankData.industryAvgScoreData.industryAvgDetails.forEach(
          (item, index) => {
            let str = ''
            // if (item.siteName.length > 3) {
            //   str = item.siteName.slice(0, 3) + '...  '
            // } else {
            str = item.siteName + '    '
            // }
            xdata.push(str + '企业  ')
            dataArr.push(item.avgScore)
            dataArr2.push(this.datalist.totalScoreAndRankData.totalScore)
            // legendData.push(item.siteName)
          }
        )
        let colorSet = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#00C8AE'
          },
          {
            offset: 1,
            color: '#226AA5'
          }
        ])
        let colorSet2 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#FF8932'
          },
          {
            offset: 1,
            color: '#DD2F21'
          }
        ])
        let colorList = ['linear-gradient(#00C8AE, #226AA5)', 'linear-gradient(#FF8932, #DD2F21)']
        let option = {
          title: {
            // text: '2016年12月长宁区合规成本分析'
          },
          tooltip: {
            trigger: 'axis',
            textStyle: {
              align: 'left'
            },
            formatter (params) {
              let Span = ''
              let Name = params[0].name.split(/\s+/)
              let Title = "<p style='text-align:center;padding:0;margin-bottom:15px;font-size:14px;line-height:14px;height:14px'>同行业评测排名" + '</p>'
              params.forEach((item, index) => {
                let dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background:' + colorList[index] + '"></span>'
                Span += "<p style='padding-left:5px;padding-right:5px;margin-bottom:10px;font-size:12px;line-height:12px;height:12px'>" + dotHtml + ' ' + Name[index] + '：' + item.value + '</p>'
              })
              return Title + Span
            },
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            // show:true,
            orient: 'horizontal',
            data: legendData,
            align: 'left',
            top: 5,
            left: 10,
            textStyle: {
              color: '#A4DCFF'
            },
            // textStyle: this.textStyle,
            itemWidth: 8,
            itemHeight: 8
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          calculable: true,
          xAxis: [
            {
              type: 'category',
              axisLabel: {
                formatter: function (params) {
                  let str = params.split(/\s+/)
                  let returnStr
                  if (str[0].length > 3) {
                    returnStr = str[0].slice(0, 2) + '... ' + str[1] + ' '
                  } else {
                    returnStr = str[0] + ' ' + str[1] + ' '
                  }
                  return returnStr
                },
                textStyle: {
                  fontSize: 12,
                  color: '#A4DCFF'
                }
              },
              axisLine: {
                lineStyle: {
                  color: '#00A2FF',
                  width: 1
                }
              },
              axisTick: {
                show: false
              },
              // splitLine: {
              //     lineStyle: {
              //         type: 'dashed',
              //         color: '#DDD'
              //     }
              // },
              data: xdata
            }
          ],
          yAxis: [
            {
              type: 'value',
              // name: '总价(万元)',
              axisLabel: {
                formatter: '{value}',
                color: '#A4DCFF',
                fontSize: 12
              },
              axisLine: {
                lineStyle: {
                  color: 'rgba(255,255,255,0)'
                  // color:'65F5FD'
                }
              },
              splitLine: {
                lineStyle: {
                  type: 'dashed',
                  color: '#385B71'
                }
              }
            }
          ],
          series: [
            {
              name: legendData[0],
              type: 'bar',
              barWidth: 17, // 柱子宽度
              barGap: 1, // 柱子之间间距
              label: {
                show: true,
                position: 'top',
                color: '#fff',
                formatter: function (params) {
                  let str = ''
                  str = params.data + '分'
                  return str
                }
              },
              itemStyle: {
                normal: {
                  color: colorSet
                  // barBorderRadius: 10,
                }
              },
              data: dataArr
            },
            {
              name: legendData[1],
              type: 'bar',
              barWidth: 17, // 柱子宽度
              barGap: 1, // 柱子之间间距
              label: {
                show: true,
                position: 'top',
                color: '#fff',
                formatter: function (params) {
                  let str = ''
                  str = params.data + '分'
                  return str
                }
              },
              itemStyle: {
                normal: {
                  color: colorSet2
                  // barBorderRadius: 10,
                }
              },
              data: dataArr2
            }
          ]
        }
        myChart.setOption(option, true)
      }
      if (sameArea) {
        let myChart = this.echarts.init(
          // document.getElementById("chart-part2")
          this.$refs.sameArea
        )
        // let xdata = ["工厂  " + "  企业"];
        let legendData = [
          this.datalist.totalScoreAndRankData.areaAvgScoreData.areaRankDetail
            .areaName,
          '企业'
        ]
        let xdata = []
        // let legendData = []
        let dataArr = []
        let dataArr2 = []
        let str = ''
        // if (this.datalist.totalScoreAndRankData.areaAvgScoreData.areaRankDetail
        //   .areaName.length > 3) {
        //   str = this.datalist.totalScoreAndRankData.areaAvgScoreData.areaRankDetail
        //     .areaName.slice(0, 3) + '...  '
        // } else {
        str = this.datalist.totalScoreAndRankData.areaAvgScoreData.areaRankDetail
          .areaName + '    '
        // }
        xdata.push(str + '企业  ')
        // xdata.push(item.siteName + "  企业");
        dataArr.push(
          this.datalist.totalScoreAndRankData.areaAvgScoreData.areaRankDetail
            .avgScore
        )
        dataArr2.push(this.datalist.totalScoreAndRankData.totalScore)
        // legendData.push(item.siteName)
        let colorSet = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#00C8AE'
          },
          {
            offset: 1,
            color: '#226AA5'
          }
        ])
        let colorSet2 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#FF8932'
          },
          {
            offset: 1,
            color: '#DD2F21'
          }
        ])
        let colorList = ['linear-gradient(#00C8AE, #226AA5)', 'linear-gradient(#FF8932, #DD2F21)']
        let option = {
          title: {
            // text: '2016年12月长宁区合规成本分析'
          },
          tooltip: {
            trigger: 'axis',
            textStyle: {
              align: 'left'
            },
            formatter (params) {
              let Span = ''
              let Name = params[0].name.split(/\s+/)
              let Title = "<p style='text-align:center;padding:0;margin-bottom:15px;font-size:14px;line-height:14px;height:14px'>同行业评测排名" + '</p>'
              params.forEach((item, index) => {
                let dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background:' + colorList[index] + '"></span>'
                Span += "<p style='padding-left:5px;padding-right:5px;margin-bottom:10px;font-size:12px;line-height:12px;height:12px'>" + dotHtml + ' ' + Name[index] + '：' + item.value + '</p>'
              })
              return Title + Span
            },
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            // show:true,
            orient: 'horizontal',
            data: legendData,
            align: 'left',
            top: 5,
            left: 10,
            textStyle: {
              color: '#A4DCFF'
            },
            // textStyle: this.textStyle,
            itemWidth: 8,
            itemHeight: 8
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          calculable: true,
          xAxis: [
            {
              type: 'category',
              formatter: function (params) {
                let str = params.split(/\s+/)
                let returnStr
                if (str[0].length > 3) {
                  returnStr = str[0].slice(0, 2) + '... ' + str[1] + ' '
                } else {
                  returnStr = str[0] + ' ' + str[1] + ' '
                }
                return returnStr
              },
              axisLabel: {
                textStyle: {
                  fontSize: 12,
                  color: '#A4DCFF'
                }
              },
              axisLine: {
                lineStyle: {
                  color: '#00A2FF',
                  width: 1
                }
              },
              axisTick: {
                show: false
              },
              // splitLine: {
              //     lineStyle: {
              //         type: 'dashed',
              //         color: '#DDD'
              //     }
              // },
              data: xdata
            }
          ],
          yAxis: [
            {
              type: 'value',
              // name: '总价(万元)',
              axisLabel: {
                formatter: '{value}',
                color: '#A4DCFF',
                fontSize: 12
              },
              axisLine: {
                lineStyle: {
                  color: 'rgba(255,255,255,0)'
                  // color:'65F5FD'
                }
              },
              splitLine: {
                lineStyle: {
                  type: 'dashed',
                  color: '#385B71'
                }
              }
            }
          ],
          series: [
            {
              name: legendData[0],
              type: 'bar',
              barWidth: 17, // 柱子宽度
              barGap: 1, // 柱子之间间距
              label: {
                show: true,
                position: 'top',
                color: '#fff',
                formatter: function (params) {
                  let str = ''
                  str = params.data + '分'
                  return str
                }
              },
              itemStyle: {
                normal: {
                  color: colorSet
                  // barBorderRadius: 10,
                }
              },
              data: dataArr
            },
            {
              name: legendData[1],
              type: 'bar',
              barWidth: 17, // 柱子宽度
              barGap: 1, // 柱子之间间距
              label: {
                show: true,
                position: 'top',
                color: '#fff',
                formatter: function (params) {
                  let str = ''
                  str = params.data + '分'
                  return str
                }
              },
              itemStyle: {
                normal: {
                  color: colorSet2
                  // barBorderRadius: 10,
                }
              },
              data: dataArr2
            }
          ]
        }
        myChart.setOption(option, true)
      }
      if (circle && this.companyRiskFlag === true) {
        let myChart = this.echarts.init(
          // document.getElementById("chart-part3")
          this.$refs.circle
        )
        let total =
          parseFloat(
            this.datalist.companyRiskevalProbability.riskevalWindProbability
          ) +
          parseFloat(
            this.datalist.companyRiskevalProbability.riskevalSystemProbability
          ) +
          parseFloat(
            this.datalist.companyRiskevalProbability.riskevalSafetyProbability
          ) +
          parseFloat(
            this.datalist.companyRiskevalProbability.riskevalHouseProbability
          ) +
          parseFloat(
            this.datalist.companyRiskevalProbability.riskevalPersonProbability
          ) +
          parseFloat(
            this.datalist.companyRiskevalProbability.riskevalDeviceProbability
          )
        total = total.toFixed(1)
        let totalString = total.toString()
        let StringArr = totalString.split('.')
        this.TotalNum = StringArr[0]
        if (StringArr[1] === '0') {
          this.Tp = ''
        } else {
          this.StringFlag = true
          this.Tp = StringArr[1]
        }
        let colorSet = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#2BD7D0'
          },
          {
            offset: 1,
            color: '#3C5163'
          }
        ])
        let colorSet2 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#FA83D4'
          },
          {
            offset: 1,
            color: '#6C2E73'
          }
        ])
        let colorSet3 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#82ECC5'
          },
          {
            offset: 1,
            color: '#006040'
          }
        ])
        let colorSet4 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#C34953'
          },
          {
            offset: 1,
            color: '#DF821E'
          }
        ])
        let colorSet5 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#491B20'
          },
          {
            offset: 1,
            color: '#CC4952'
          }
        ])
        let colorSet6 = new echarts.graphic.LinearGradient(1, 0, 0, 0, [
          {
            offset: 0,
            color: '#1D5788'
          },
          {
            offset: 1,
            color: '#74CFF3'
          }
        ])
        let colorSet7 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#123858'
          },
          {
            offset: 1,
            color: '#236BA8'
          }
        ])
        let option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)'
          },
          title: {
            // text: this.TotalNum + this.Tp + '%',
            // text:'99.99%',
            subtext: '存在隐患',
            left: 'center',
            top: '55%',
            itemGap: 3,
            textStyle: {
              fontSize: 14,
              color: '#FF4141'
            },
            subtextStyle: {
              fontSize: 11,
              color: '#FF4141'
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['35%', '48%'],
              hoverAnimation: false,
              stillShowZeroSum: false,
              // silent: true,
              label: {
                normal: {
                  show: true,
                  // position: 'center',
                  // formatter: "  {per|{d}%} {b|{b}}   ",
                  formatter: function (params) {
                    var str = ''
                    if (params.name !== '无隐患' && params.value !== 0) {
                      str =
                        '{per|' + params.value + '%}{b|' + params.name + '}'
                    } else {
                      str = '{b|' + params.name + '}'
                    }
                    return str
                  },
                  rich: {
                    a: {
                      color: '#999',
                      lineHeight: 14,
                      align: 'center'
                    },
                    b: {
                      color: '#FFFFFF',
                      fontSize: 11,
                      lineHeight: 33
                    },
                    per: {
                      color: '#0EEBFF',
                      fontSize: 11
                      // backgroundColor: '#334455',
                      // padding: [2, 4]
                    }
                  }
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: '12',
                    fontWeight: 'bold'
                  }
                }
              },
              data: [
                {
                  value: parseFloat(
                    this.datalist.companyRiskevalProbability
                      .riskevalWithoutProbability
                  ),
                  name: this.datalist.companyRiskevalProbability
                    .riskevalWithoutName,
                  itemStyle: {
                    normal: {
                      color: colorSet
                    }
                  }
                },
                {
                  value:
                    parseFloat(
                      this.datalist.companyRiskevalProbability
                        .riskevalWindProbability
                    ) === 0
                      ? null
                      : parseFloat(
                        this.datalist.companyRiskevalProbability
                          .riskevalWindProbability
                      ),
                  name: this.datalist.companyRiskevalProbability
                    .riskevalWindName,
                  itemStyle: {
                    normal: {
                      color: colorSet2
                    }
                  }
                },
                {
                  value:
                    parseFloat(
                      this.datalist.companyRiskevalProbability
                        .riskevalSafetyProbability
                    ) === 0
                      ? null
                      : parseFloat(
                        this.datalist.companyRiskevalProbability
                          .riskevalSafetyProbability
                      ),
                  name: this.datalist.companyRiskevalProbability
                    .riskevalSafetyName,
                  itemStyle: {
                    normal: {
                      color: colorSet4
                    }
                  }
                },
                {
                  value:
                    parseFloat(
                      this.datalist.companyRiskevalProbability
                        .riskevalSystemProbability
                    ) === 0
                      ? null
                      : parseFloat(
                        this.datalist.companyRiskevalProbability
                          .riskevalSystemProbability
                      ),
                  name: this.datalist.companyRiskevalProbability
                    .riskevalSystemName,
                  itemStyle: {
                    normal: {
                      color: colorSet3
                    }
                  }
                },
                {
                  value:
                    parseFloat(
                      this.datalist.companyRiskevalProbability
                        .riskevalHouseProbability
                    ) === 0
                      ? null
                      : parseFloat(
                        this.datalist.companyRiskevalProbability
                          .riskevalHouseProbability
                      ),
                  name: this.datalist.companyRiskevalProbability
                    .riskevalHouseName,
                  itemStyle: {
                    normal: {
                      color: colorSet5
                    }
                  }
                },
                {
                  value:
                    parseFloat(
                      this.datalist.companyRiskevalProbability
                        .riskevalPersonProbability
                    ) === 0
                      ? null
                      : parseFloat(
                        this.datalist.companyRiskevalProbability
                          .riskevalPersonProbability
                      ),
                  name: this.datalist.companyRiskevalProbability
                    .riskevalPersonName,
                  itemStyle: {
                    normal: {
                      color: colorSet7
                    }
                  }
                },
                {
                  value:
                    parseFloat(
                      this.datalist.companyRiskevalProbability
                        .riskevalDeviceProbability
                    ) === 0
                      ? null
                      : parseFloat(
                        this.datalist.companyRiskevalProbability
                          .riskevalDeviceProbability
                      ),
                  name: this.datalist.companyRiskevalProbability
                    .riskevalDeviceName,
                  itemStyle: {
                    normal: {
                      color: colorSet6
                    }
                  }
                }
              ]
            }
          ]
        }
        myChart.setOption(option, true)
      }
      if (leftcircle && this.riskevalDeviceFlag === true) {
        let seriesData = []
        let legendData = []
        let TotalNumb = null
        let myChart = this.echarts.init(
          // document.getElementById("chart-part4")
          this.$refs.leftcircle
        )
        this.datalist.deviceRiskevalProbabilityList.forEach((item, index) => {
          if (parseFloat(item.deivceProbability) !== 0) {
            legendData.push({
              value: parseFloat(item.deivceProbability),
              name: item.deviceName + '缺失'
            })
          }
          TotalNumb = this.floatAdd(
            TotalNumb,
            parseFloat(item.deivceProbability)
          )
          let data1 = {
            value: parseFloat(item.deivceProbability),
            name: item.deviceName + '缺失'
          }
          let data2 = {
            value: parseFloat(
              this.datalist.companyRiskevalProbability.riskevalDeviceProbability
            ),
            name: '',
            // show:false,
            itemStyle: {
              color: '#16436A'
            },
            legend: {
              show: false
            },
            label: {
              show: false
            }
          }
          let seriesObj = {
            name: item.deviceName + '缺失',
            value: parseFloat(item.deivceProbability),
            type: 'pie',
            hoverAnimation: false,
            tooltip: {
              trigger: 'item',
              formatter: (params) => {
                let str = ''
                if (params.value === parseFloat(this.datalist.companyRiskevalProbability.riskevalDeviceProbability)) {
                  if (params.dataIndex === 1) {
                    str = ''
                  } else {
                    str = params.name + '：' + params.value + '%'
                  }
                } else {
                  str = params.name + '：' + params.value + '%'
                }
                return str
              }
            },
            label: {
              show: false
            },
            center: ['31%', '55%'],
            radius: [80 - index * 7 + '%', 75 - index * 7 + '%'],
            data: [data1, data2],
            itemStyle: {
              normal: {
                color: function (params) {
                  let colorLines = myColor
                  return colorLines[index]
                }
              }
            }
          }
          seriesData.push(seriesObj)
          // option.series.push({
          //   type: "bar",
          //   name: item.deviceName + "缺失",
          //   coordinateSystem: "polar",
          //   barWidth: 10, //宽度
          //   barGap: 1,
          //   barCategoryGap: "40%",
          //   data: [parseFloat(item.deivceProbability)]
          //   // name: item.deviceName,
          //   // value: parseFloat(item.deivceProbability)
          // });
          // option.radiusAxis.data.push(item.deviceName);
          // dataNameArr.push(item.deviceName);
        })
        let colorSet = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#FFAE12'
          },
          {
            offset: 1,
            color: '#C33C59'
          }
        ])
        let colorSet2 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#CC4952'
          },
          {
            offset: 1,
            color: '#491B20'
          }
        ])
        let colorSet3 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#D570B5'
          },
          {
            offset: 1,
            color: '#6C2E73'
          }
        ])
        let colorSet4 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#2B84CF'
          },
          {
            offset: 1,
            color: '#1A4F7C'
          }
        ])
        let colorSet5 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#74CFF3'
          },
          {
            offset: 1,
            color: '#186788'
          }
        ])
        let colorSet6 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#6FC9A8'
          },
          {
            offset: 1,
            color: '#006040'
          }
        ])
        let colorSet7 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#FFAE12'
          },
          {
            offset: 1,
            color: '#AA5319'
          }
        ])
        let colorSet8 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#916FCB'
          },
          {
            offset: 1,
            color: '#553D71'
          }
        ])
        let colorSet9 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#97CE00'
          },
          {
            offset: 1,
            color: '#357D12'
          }
        ])
        let colorSet10 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#D1C0A5'
          },
          {
            offset: 1,
            color: '#81511C'
          }
        ])
        let myColor = [
          colorSet,
          colorSet2,
          colorSet3,
          colorSet4,
          colorSet5,
          colorSet6,
          colorSet7,
          colorSet8,
          colorSet9,
          colorSet10
        ]
        var option
        if (this.datalist.deviceRiskevalProbabilityList.length >= 8) {
          option = {
            color: myColor,
            tooltip: {
              trigger: 'item',
              formatter: '{a} : {c}%'
            },
            title: {
              text: parseFloat(this.datalist.companyRiskevalProbability.riskevalDeviceProbability) + '%',
              subtext: '缺失',
              left: '29%',
              top: '50%',
              itemGap: 1,
              textAlign: 'center',
              textStyle: {
                fontSize: 6,
                color: '#0EEBFF'
              },
              subtextStyle: {
                fontSize: 6,
                color: '#ffffff'
              }
            },
            legend: {
              color: myColor,
              type: 'scroll',
              orient: 'vertical',
              top: 'center',
              left: '59%',
              data: legendData,
              formatter: function (name) {
                // legendData.push({
                //   value: parseFloat(item.deivceProbability),
                //   name: item.deviceName + "缺失"
                // })
                let target = 0

                for (let i = 0; i < legendData.length; i++) {
                  if (legendData[i].name === name) {
                    target = legendData[i].value
                  }
                }
                let arr = ['{b|' + name + '}  {a|' + target + '%}']
                return arr
              },
              textStyle: {
                color: '#ffffff',
                rich: {
                  b: {
                    fontSize: 8,
                    color: '#ffffff'
                  },
                  a: {
                    fontSize: 8,
                    color: '#0EEBFF'
                  }
                }
              },
              // textStyle: this.textStyle,
              itemWidth: 10,
              itemHeight: 10,
              itemGap: 5
            },
            dataset: {
              source: []
            },
            series: seriesData
          }
        } else if (
          this.datalist.deviceRiskevalProbabilityList.length >= 5 &&
          this.datalist.deviceRiskevalProbabilityList.length <= 7
        ) {
          option = {
            tooltip: {
              trigger: 'item',
              formatter: '{a} : {c}%'
            },
            title: {
              text: parseFloat(this.datalist.companyRiskevalProbability.riskevalDeviceProbability) + '%',
              subtext: '缺失',
              left: '29%',
              top: '49%',
              itemGap: 1,
              textAlign: 'center',
              textStyle: {
                fontSize: 12,
                color: '#0EEBFF'
              },
              subtextStyle: {
                fontSize: 12,
                color: '#ffffff'
              }
            },
            color: myColor,
            legend: {
              type: 'scroll',
              orient: 'vertical',
              top: 'center',
              left: '60%',
              data: legendData,
              formatter: function (name) {
                // legendData.push({
                //   value: parseFloat(item.deivceProbability),
                //   name: item.deviceName + "缺失"
                // })
                let target = 0

                for (let i = 0; i < legendData.length; i++) {
                  if (legendData[i].name === name) {
                    target = legendData[i].value
                  }
                }
                let arr = ['{b|' + name + '}  {a|' + target + '%}']
                return arr
              },
              textStyle: {
                color: '#ffffff',
                rich: {
                  b: {
                    fontSize: 10,
                    color: '#ffffff'
                  },
                  a: {
                    fontSize: 10,
                    color: '#0EEBFF'
                  }
                }
              },
              // textStyle: this.textStyle,
              itemWidth: 10,
              itemHeight: 10,
              itemGap: 10
            },
            dataset: {
              source: []
            },
            series: seriesData
          }
        } else {
          option = {
            color: myColor,
            tooltip: {
              trigger: 'item',
              formatter: '{a} : {c}%'
            },
            title: {
              text: parseFloat(this.datalist.companyRiskevalProbability.riskevalDeviceProbability) + '%',
              subtext: '缺失',
              left: '29%',
              top: 'center',
              itemGap: 5,
              textAlign: 'center',
              textStyle: {
                fontSize: 25,
                color: '#0EEBFF'
              },
              subtextStyle: {
                fontSize: 20,
                color: '#ffffff'
              }
            },
            legend: {
              color: myColor,
              type: 'scroll',
              orient: 'vertical',
              top: 'center',
              left: '59.5%',
              data: legendData,
              formatter: function (name) {
                // legendData.push({
                //   value: parseFloat(item.deivceProbability),
                //   name: item.deviceName + "缺失"
                // })
                let target = 0

                for (let i = 0; i < legendData.length; i++) {
                  if (legendData[i].name === name) {
                    target = legendData[i].value
                  }
                }
                let arr = ['{b|' + name + '}  {a|' + target + '%}']
                return arr
              },
              textStyle: {
                color: '#ffffff',
                rich: {
                  b: {
                    fontSize: 12,
                    color: '#ffffff'
                  },
                  a: {
                    fontSize: 13,
                    color: '#0EEBFF'
                  }
                }
              },
              // textStyle: this.textStyle,
              itemWidth: 10,
              itemHeight: 10,
              itemGap: 15
            },
            dataset: {
              source: []
            },
            series: seriesData
          }
        }

        // option.series.length = 0;
        // option.radiusAxis.data.length = 0;

        myChart.setOption(option, true)
      }
      if (rightcircle && this.riskevalSystemFlag === true) {
        let myChart = this.echarts.init(
          // document.getElementById("chart-part5")
          this.$refs.rightcircle
        )
        // var list = [['product', '消防设备缺失情况', '消防设备缺失情况']]
        let colorSet = new echarts.graphic.LinearGradient(1, 0, 0, 0, [
          {
            offset: 0,
            color: '#1FB0EF'
          },
          {
            offset: 1,
            color: '#1A6084'
          }
        ])
        let colorSet2 = new echarts.graphic.LinearGradient(1, 0, 0, 0, [
          {
            offset: 0,
            color: '#DF821E'
          },
          {
            offset: 1,
            color: '#C34953'
          }
        ])
        let colorSet3 = new echarts.graphic.LinearGradient(1, 0, 0, 0, [
          {
            offset: 0,
            color: '#82ECC5'
          },
          {
            offset: 1,
            color: '#006040'
          }
        ])
        let colorSet4 = new echarts.graphic.LinearGradient(1, 0, 0, 0, [
          {
            offset: 0,
            color: '#CC1C4F'
          },
          {
            offset: 1,
            color: '#5C0000'
          }
        ])
        let colorSet5 = new echarts.graphic.LinearGradient(1, 0, 0, 0, [
          {
            offset: 0,
            color: '#D871B5'
          },
          {
            offset: 1,
            color: '#6A2A59'
          }
        ])
        let colorSet6 = new echarts.graphic.LinearGradient(1, 0, 0, 0, [
          {
            offset: 0,
            color: '#916fcb'
          },
          {
            offset: 1,
            color: '#553d71'
          }
        ])
        let colorSet7 = new echarts.graphic.LinearGradient(1, 0, 0, 0, [
          {
            offset: 0,
            color: '#97ce00'
          },
          {
            offset: 1,
            color: '#357d12'
          }
        ])
        let colorSet8 = new echarts.graphic.LinearGradient(1, 0, 0, 0, [
          {
            offset: 0,
            color: '#d1c0a5'
          },
          {
            offset: 1,
            color: '#81511c'
          }
        ])
        let myColor = [
          colorSet,
          colorSet2,
          colorSet3,
          colorSet4,
          colorSet5,
          colorSet6,
          colorSet7,
          colorSet8
        ]
        let list = []
        // let data = [];
        // let titlename = [];
        // let leftData = [];
        this.datalist.systemRiskevalProbabilityOuts.forEach((item, index) => {
          let arr = []
          arr[0] = item.systemName
          arr[1] = parseFloat(
            this.datalist.companyRiskevalProbability.riskevalSystemProbability
          )
          arr[2] = parseFloat(item.systemProbability)
          list.push(arr)
          // data.push(parseFloat(item.systemProbability));
          // titlename.push(item.systemName);
          // leftData.push(parseFloat(item.systemProbability) + "%");
        })

        let option = {}
        if (list.length > 5) {
          option = {
            tooltip: {
              trigger: 'item',
              formatter: function (params) {
                let str = ''
                if (params.seriesIndex === 1) {
                  if (params.data[1] === params.data[2]) {
                    str = ''
                  } else {
                    str = params.data[0] + '：' + params.data[2] + '%'
                  }
                }

                return str
              }
            },
            grid: {
              top: '15%',
              bottom: '5%',
              left: '20',
              right: '20%'
            },
            dataset: {
              source: []
            },
            xAxis: {
              show: false
            },
            yAxis: {
              type: 'category',
              inverse: true,
              show: false,
              max: 5
            },
            series: [
              {
                type: 'bar',
                barWidth: 12,
                barGap: '-100%',
                z: 1,
                itemStyle: {
                  color: '#16436A',
                  barBorderRadius: 9
                },
                label: {
                  normal: {
                    show: true,
                    position: 'right',
                    textStyle: {
                      color: '#ffffff'
                    },
                    offset: [10, 0],
                    formatter: function (params) {
                      return params.value[2] + '%'
                    }
                  }
                }
              },
              {
                type: 'bar',
                barWidth: 12,
                barGap: '-100%',
                z: 2,
                itemStyle: {
                  barBorderRadius: 9,
                  color: function (params) {
                    // 颜色定制显示（按顺序
                    let colorLines = myColor
                    return colorLines[params.dataIndex]
                  }
                },
                label: {
                  normal: {
                    show: true,
                    position: 'insideLeft',
                    color: '#FFFFFF',
                    fontSize: 10,
                    offset: [0, 0],
                    formatter: '{b}'
                  }
                }
              }
            ]
          }
        } else {
          option = {
            tooltip: {
              trigger: 'item',
              formatter: function (params) {
                let str = ''
                if (params.seriesIndex === 1) {
                  if (params.data[1] === params.data[2]) {
                    str = ''
                  } else {
                    str = params.data[0] + '：' + params.data[2] + '%'
                  }
                }

                return str
              }
            },
            grid: {
              top: '50',
              bottom: '5',
              left: '20',
              right: '20%'
            },
            dataset: {
              source: []
            },
            xAxis: {
              show: false
            },
            yAxis: {
              type: 'category',
              inverse: true,
              show: false,
              max: 5
            },
            series: [
              {
                type: 'bar',
                barWidth: 12,
                barGap: '-100%',
                z: 1,
                itemStyle: {
                  color: '#16436A',
                  barBorderRadius: 9
                },
                label: {
                  normal: {
                    show: true,
                    position: 'right',
                    textStyle: {
                      color: '#ffffff'
                    },
                    offset: [10, 0],
                    formatter: function (params) {
                      return params.value[2] + '%'
                    }
                  }
                }
              },
              {
                type: 'bar',
                barWidth: 12,
                barGap: '-100%',
                z: 2,
                itemStyle: {
                  barBorderRadius: 9,
                  color: function (params) {
                    // 颜色定制显示（按顺序
                    let colorLines = myColor
                    return colorLines[params.dataIndex]
                  }
                },
                label: {
                  normal: {
                    show: true,
                    position: 'insideLeft',
                    color: '#FFFFFF',
                    fontSize: 10,
                    offset: [0, 0],
                    formatter: '{b}'
                  }
                }
              }
            ]
          }
        }
        option.dataset.source = list
        myChart.setOption(option, true)
      }
      if (this.echartList) {
        let Earea = document.getElementsByClassName('echart')
        let EareaWidth = Earea[0].clientWidth
        for (let i = 0; i < this.echartList.length; i++) {
          Earea[i].style.width = EareaWidth + 'px'
          let myChart = this.echarts.init(this.$refs.echart[i])
          let xdata = []
          let dataArr = []
          let dataArr2 = []
          this.echartDataArr[i].forEach((item, index) => {
            if (item.device_name !== '都没有') {
              xdata.push(item.device_name)
              dataArr.push(item.norm_number)
              dataArr2.push(item.real_number)
            }
          })

          // let legendData = ["按照国家规范应安装个数", "场所实际应安装个数"];
          let legendData = ['按照国家规范应安装个数', '场所实际安装个数']

          let colorSet = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#00C8AE'
            },
            {
              offset: 1,
              color: '#226AA5'
            }
          ])
          let colorSet2 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#FF8932'
            },
            {
              offset: 1,
              color: '#DD2F21'
            }
          ])
          let option = {
            title: {
              // text: '2016年12月长宁区合规成本分析'
            },
            tooltip: {
              trigger: 'axis',
              align: 'center',
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow',
                // align: 'center'
              },
              textStyle: {
                fontSize: 8
              }
            },
            legend: {
              // show:true,
              orient: 'vertical',
              data: legendData,
              align: 'left',
              top: 0,
              left: 5,
              textStyle: {
                color: '#A4DCFF',
                fontSize: 10
              },
              // textStyle: this.textStyle,
              itemWidth: 10,
              itemHeight: 10
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            calculable: true,
            xAxis: [
              {
                type: 'category',
                axisLabel: {
                  interval: 0,
                  rotate: 0,
                  formatter: function (value) {
                    return (value.length > 3 ? (value.slice(0, 3) + '...') : value)
                  },
                  textStyle: {
                    fontSize: 10,
                    color: '#A4DCFF'
                  }
                },
                axisLine: {
                  lineStyle: {
                    color: '#00A2FF',
                    width: 1
                  }
                },
                axisTick: {
                  show: false
                },
                // splitLine: {
                //     lineStyle: {
                //         type: 'dashed',
                //         color: '#DDD'
                //     }
                // },
                data: xdata
              }
            ],
            yAxis: [
              {
                type: 'value',
                // name: '总价(万元)',
                axisLabel: {
                  formatter: '{value}',
                  color: '#A4DCFF',
                  fontSize: 12
                },
                axisLine: {
                  lineStyle: {
                    color: 'rgba(255,255,255,0)'
                    // color:'65F5FD'
                  }
                },
                splitLine: {
                  lineStyle: {
                    type: 'dashed',
                    color: '#385B71'
                  }
                }
              }
            ],
            series: [
              {
                name: legendData[0],
                type: 'bar',
                barWidth: 17, // 柱子宽度
                barGap: 0.3, // 柱子之间间距
                label: {
                  show: true,
                  position: 'top',
                  color: '#fff'
                },
                itemStyle: {
                  normal: {
                    color: colorSet
                    // barBorderRadius: 10,
                  }
                },
                data: dataArr
              },
              {
                name: legendData[1],
                type: 'bar',
                barWidth: 17, // 柱子宽度
                barGap: 0.3, // 柱子之间间距
                label: {
                  show: true,
                  position: 'top',
                  color: '#fff'
                },
                itemStyle: {
                  normal: {
                    color: colorSet2
                    // barBorderRadius: 10,
                  }
                },
                data: dataArr2
              }
            ]
          }
          myChart.setOption(option, true)
        }
      }
    },

    bugcg () {
      let yjcg = []
      this.shopqqList.forEach((item, index) => {
        yjcg.push(item.tails)
      })
      this.shopqqList.forEach((item, index) => {
        yjcg[index].riskeval_result_id = parseInt(this.getResultId)
      })
      this.shopqqList.forEach((item, index) => {
        yjcg[index].number = item.req_number
      })
      axios({
        method: 'post',
        url: this.companyUrl + '/shoppingCart/matchingGoods',
        data: yjcg,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          'Cache-control': 'no-cache',
          Pragma: 'no-cache',
          Expires: 0,
          zxzxkey: ''
        },
        dataType: 'json'
      }).then(resj => {
        var d = new Date()
        var jsonStr = JSON.stringify(resj.data.data)
        d.setHours(d.getHours() + 1) // 保存一个小时
        localStorage.removeItem('shop')
        localStorage.setItem('shop', jsonStr)
        localStorage.setItem('resultId', this.getResultId)
        localStorage.setItem('onceOrder', this.onceOrder)
        this.$router.push({ path: 'purchasing' })
      })
    },

    bugsp () {
      if (this.tkshow) {
        this.ztcxafter()
      } else {
        this.shopzzList = []
        this.shopqqList.forEach((item, index) => {
          this.shopzzList.push(item.tails)
        })
        this.shopzzList.forEach((item, index) => {
          this.shopzzList[index].riskeval_result_id = parseInt(
            this.getResultId
          )
        })
        this.shopqqList.forEach((item, index) => {
          this.shopzzList[index].number = item.req_number - item.commit_number
        })
        this.shopzzList.forEach((item, index) => {
          if (item.number < 1) {
            this.shopzzList.splice(index, 1)
          }
        })
        this.shopzzList.forEach((item, index) => {
          if (item.number < 1) {
            this.shopzzList.splice(index, 1)
          }
        })
        this.shopzzList.forEach((item, index) => {
          if (item.number < 1) {
            this.shopzzList.splice(index, 1)
          }
        })
        axios({
          method: 'post',
          url: this.companyUrl + '/shoppingCart/matchingGoods',
          data: this.shopzzList,
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            'Cache-control': 'no-cache',
            Pragma: 'no-cache',
            Expires: 0,
            zxzxkey: ''
          },
          dataType: 'json'
        }).then(resj => {
          var d = new Date()
          var jsonStr = JSON.stringify(resj.data.data)
          d.setHours(d.getHours() + 1) // 保存一个小时
          localStorage.removeItem('shop')
          localStorage.setItem('shop', jsonStr)
          localStorage.setItem('resultId', this.getResultId)
          localStorage.setItem('onceOrder', this.onceOrder)
          this.$router.push({ path: 'purchasing' })
        })
      }
    },
    ztcx () {
      this.utils.GET(
        this.companyUrl +
        '/zxOrder/getOrderByEvalResultId?riskevalResultId=' +
        this.getResultId,
        resj => {
          if (resj.data.length > 0) {
            this.dd = resj.data.length
            // this.dialogTableVisible = true
            this.tkshow = true
          } else {
            this.changetk = true
            if (this.shopqqList.length !== 0) {
              if (this.numjj === this.shopqqList.length && this.changetk) {
                this.yjjj = false
              }
            }
          }
        },
        err => {
          if (err.message === '该风险测评记录暂无未支付订单') {
            console.log('第一次评测没有未采购评测的东西')
          }
        }
      )
    },
    ztcxafter () {
      this.utils.GET(
        this.companyUrl +
        '/zxOrder/getOrderByEvalResultId?riskevalResultId=' +
        this.getResultId,
        resj => {
          if (resj.data.length > 0) {
            this.dd = resj.data.length
            this.dialogTableVisible = true
          }
        },
        err => {
          if (err.message === '该风险评测记录尚无转化订单') {
            console.log('第一次评测没有未采购评测的东西')
          }
        }
      )
    }
  },
  watch: {
    payType (value) {
      if (value === 'wx_pub_qr') {
        setTimeout(() => {
          this.aliPay()
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  line-height: 0;
  font-style: normal;
  word-spacing: 0px;
}
body {
  padding-top: constant(safe-area-inset-top) !important;
  padding-left: constant(safe-area-inset-left) !important;
  padding-right: constant(safe-area-inset-right) !important;
  padding-bottom: constant(safe-area-inset-bottom) !important;
  padding-top: env(safe-area-inset-top) !important;
  padding-left: env(safe-area-inset-left) !important;
  padding-right: env(safe-area-inset-right) !important;
  padding-bottom: env(safe-area-inset-bottom) !important;
}
.clearfix:before {
  content: "";
  display: table;
}
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.cssOuterBox {
  width: 100%;
  text-align: center;
  font-size: 0;
  background: url(./images/bg.jpg) no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
  .cssMainBody {
    width: 100%;
    height: auto;
    background: #113452;
    margin: 0px auto;
    .rank {
      // border: 1px solid transparent;
      width: 100%;
      // height: 1138px;
      background: url(./images/result_bg1.jpg) no-repeat top center;
      background-size: 100% 34%;
      transition: transform 0.3s ease-in-out;
      position: relative;
      transform: translate3d(0, 40px, 0);
      visibility: visible;
      opacity: 0;
      transition: all 0s;
      -webkit-transition: all 0s;
      -ms-transition: all 0s;
      -moz-transition: all 0s;
      padding: 15px 15px 0 15px;
      margin-bottom: 32.5px;
      .resultTit {
        height: 20px;
        font-size: 20px;
        line-height: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        margin-top: 15px;
        margin-bottom: 9px;
        text-align: center;
      }
      .resultSubTit {
        height: 12px;
        font-size: 12px;
        line-height: 12px;
        color: #a4dcff;
        text-align: center;
        display: block;
        margin: 0 auto 17px auto;
      }
      .resultNumbArea {
        width: 156px;
        height: 165px;
        text-align: center;
        margin: 0 auto 41px auto;
        border: 1px solid transparent;
        .tit {
          margin: 38px auto 10px auto;
          line-height: 11px;
          font-size: 11px;
          color: #ffffff;
          text-align: center;
        }
        .Numb {
          height: 29px;
          line-height: 29px;
          font-size: 29px;
          font-weight: bold;
          color: #ffff00;
          margin-bottom: 10px;
          span {
            font-size: 30px;
            line-height: 30px;
            display: inline-block;
            vertical-align: top;
          }
        }
        .ranklevel {
          /* display: block; */
          /* width: 143px; */
          line-height: 15px;
          border: 2px solid #eb0d13;
          border-radius: 50px;
          font-size: 10px;
          color: #730609;
          background: #ffff00;
          margin: 0 auto;
          display: inline-block;
          padding: 0px 4px;
          .wranning {
            width: 12px;
            height: 12px;
            display: inline-block;
            line-height: 10px;
            font-size: 10px;
            color: #eb0d13;
            border: 1px solid #eb0d13;
            border-radius: 50%;
            vertical-align: top;
            margin-top: 1px;
            margin-right: 3px;
          }
        }
      }
      .companyTestRank {
        position: relative;
        width: 100%;
        margin: 0 auto;
        font-size: 0;
        .companyRank {
          display: inline-block;
          width: 100%;
          height: 101px;
          background: #1c5686;
          vertical-align: top;
          text-align: left;
          // flag 24px centerbox fire rightbox  num medal TotalRank num
          .leftRank {
            position: relative;
            display: inline-block;
            width: 50%;
            .flag {
              display: inline-block;
              position: relative;
              width: 89%;
              height: 53px;
              // margin-right: calc(50% - 130px);
              margin-top: 27px;
              // border-right: 1px solid transparent;
              // background:  url(./images/flag.png)no-repeat left center;
              // background-size: 100% 100%;
              overflow: hidden;
              .centerbox {
                height: 45px;
                text-align: center;
                border-right: none;
                .fire {
                  width: 25.5px;
                  height: 35px;
                  border: none;
                  background: url(./images/fire.png) no-repeat center center;
                  background-size: cover;
                  display: inline-block;
                  margin-top: 11px;
                  margin-right: 10px;
                }
                .rightbox {
                  display: inline-block;
                  vertical-align: top;
                  margin-top: 10px;
                  p {
                    height: 18px;
                    line-height: 18px;
                    font-size: 18px;
                    font-family: Source Han Sans CN;
                    font-weight: 800;
                    color: rgba(255, 255, 0, 1);
                    margin-bottom: 4px;
                    text-align: left;
                  }
                  p:last-child {
                    height: 12px;
                    line-height: 12px;
                    font-size: 12px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    margin-bottom: 0px;
                    white-space: nowrap;
                  }
                }
              }
            }
            .flag.hide::after {
              content: "";
              position: absolute;
              top: 0px;
              right: -0.05rem;
              width: 4px;
              height: 53px;
              z-index: 1000;
              background: #1c5686;
            }
          }
          .rightRank {
            display: inline-block;
            width: 50%;
            text-align: center;
            position: relative;
            white-space: nowrap;
            vertical-align: top;
            margin-top: 36px;
            .medal {
              display: inline-block;
              width: 28.5px;
              height: 39.5px;
              background: url(./images/jp.png) no-repeat center center;
              background-size: cover;
              margin-right: 6px;
            }
            .TotalRank {
              width: 90px;
              height: 56px;
              display: inline-block;
              // position: absolute;
              // left: 0;
              // right: 0;
              // margin-top: 36.5px;
              vertical-align: top;
              p {
                height: 18px;
                line-height: 18px;
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 800;
                color: #0eebff;
                margin-bottom: 4px;
                text-align: left;
              }
              p:last-child {
                height: 11px;
                line-height: 11px;
                font-size: 11px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                margin-bottom: 0px;
              }
            }
          }
        }
        // <!--leftPart p span p:last-child  rightPart  p span p:last-child-->
        .averageRank {
          position: relative;
          display: inline-block;
          width: 100%;
          height: 71px;
          vertical-align: top;
          background: #194d79;
          text-align: center;
          .leftPart {
            width: calc(50% - 8px);
            height: 59px;
            display: inline-block;
            vertical-align: top;
            margin-top: 18px;
            margin-left: 8px;
            text-align: center;
            p {
              display: inline-block;
              height: 18px;
              line-height: 18px;
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: 800;
              color: #0eebff;
              margin-bottom: 9.5px;
              text-align: left;
            }
            span {
              display: inline-block;
              width: 48px;
              height: 20px;
              background: url(./images/ranking.png) no-repeat center center;
              background-size: cover;
              line-height: 24px;
              font-size: 12px;
              color: #0eebff;
              margin-left: 7.5px;
              text-align: right;
              padding-right: 10px;
              vertical-align: top;
            }
            p:last-child {
              display: block;
              text-align: center;
              height: 11px;
              line-height: 11px;
              font-size: 11px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              margin-bottom: 0px;
            }
            // height: 127
          }
          .rightPart {
            width: calc(50% - 8px);
            height: 59px;
            display: inline-block;
            margin-top: 18px;
            margin-left: 8px;
            vertical-align: top;
            text-align: center;
            p {
              display: inline-block;
              height: 18px;
              line-height: 18px;
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: 800;
              color: #0eebff;
              margin-bottom: 9.5px;
              text-align: center;
            }
            span {
              display: inline-block;
              width: 48px;
              height: 20px;
              background: url(./images/ranking.png) no-repeat center center;
              background-size: cover;
              line-height: 24px;
              font-size: 12px;
              color: #0eebff;
              margin-left: 7.5px;
              text-align: right;
              padding-right: 10px;
              vertical-align: top;
            }
            p:last-child {
              display: block;
              text-align: center;
              height: 11px;
              line-height: 11px;
              font-size: 11px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              margin-bottom: 0px;
              margin-right: 3px;
            }
            // height: 127
          }
        }
        .averageRank::after {
          position: absolute;
          top: 0;
          left: 50%;
          content: "";
          width: 1px;
          height: 71px;
          background: #1c5686;
        }
        .sameIndustryRank {
          display: inline-block;
          width: 100%;
          height: 25px;
          text-align: center;
          line-height: 25px;
          font-size: 13px;
          color: #ffffff;
          background: #154266;
        }
        .sameAreaRank {
          display: inline-block;
          width: 100%;
          height: 25px;
          text-align: center;
          line-height: 25px;
          font-size: 13px;
          color: #ffffff;
          background: #154266;
        }
        .sameIndustry {
          width: 100%;
          height: 210px;
          display: inline-block;
          background: #174972;
        }
        .sameArea {
          width: 100%;
          height: 210px;
          display: inline-block;
          background: #16456c;
        }
      }
      .companyTestRank:before {
        position: absolute;
        content: "企业评测排名";
        width: 100%;
        height: 27px;
        top: -12px;
        left: 0;
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 27px;
        background: url(./images/title_short.png) no-repeat center center;
        background-size: cover;
        z-index: 1;
      }
    }
    .rank.js_worldofwar {
      transform: translate(0px, 0px);
      opacity: 1;
      transition: all 0.6s;
      -webkit-transition: all 0.6s;
      -ms-transition: all 0.6s;
      -moz-transition: all 0.6s;

      transition-delay: 0.2s;
      -moz-transition-delay: 0.2s;
      -webkit-transition-delay: 0.2s;
      /* position: absolute */
    }
    .probability {
      position: relative;
      width: 100%;
      height: 560px;
      // height: 977px;
      background: url(./images/result_bg2.jpg) no-repeat center center;
      background-size: 100% 100%;
      transition: transform 0.3s ease-in-out;
      position: relative;
      transform: translate3d(0, 40px, 0);
      visibility: visible;
      opacity: 0;
      transition: all 0s;
      -webkit-transition: all 0s;
      -ms-transition: all 0s;
      -moz-transition: all 0s;
      padding: 0 15px 0 15px;
      border: 1px solid transparent;
      .icon {
        display: block;
        width: 114px;
        height: 114px;
        background: url(./images/good_icon.png) no-repeat center center;
        background-size: auto 100%;
        margin: 65px auto 24px auto;
      }
      p {
        text-align: center;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        color: #fff;
        span {
          font-size: 18px;
          color: #0eebff;
          font-style: italic;
        }
      }
      .circle {
        width: 100%;
        height: 260px;
      }
      .circle::after {
        position: absolute;
        content: "";
        width: 28px;
        height: 38px;
        background: url(./images/fire_gif.png) no-repeat center center;
        background-size: cover;
        top: calc(50% - 38px);
        left: calc(50% - 14px);
      }
      .innerP {
        height: 230px;
        line-height: 230px;
        color: #0eebff;
      }
      .centerRowbox {
        position: absolute;
        left: 0;
        width: 100%;
        height: 240px;
        margin: 0 auto 10px auto;
        overflow-x: scroll;
        overflow-y: hidden;
        display: inline-block;
        .rowScroll {
          padding: 0 0 0 15px;
          white-space: nowrap;
        }
        .leftBox {
          position: relative;
          display: inline-block;
          width: 345px;
          height: 240px;
          background: url(./images/result_bg6.png) no-repeat center center;
          background-size: 100% 100%;
          margin-right: 7px;
          padding-right: 8px;
          vertical-align: top;
        }
        .leftBox::before {
          position: absolute;
          content: "设备设施不齐全隐患概率";
          top: 11px;
          left: 13px;
          height: 14px;
          line-height: 14px;
          font-size: 14px;
          color: #ffffff;
        }
        .leftBox::after {
          position: absolute;
          content: "";
          top: 16.5px;
          right: 3px;
          height: 5px;
          width: 125px;
          background: url(./images/title_bg.png) no-repeat center center;
          background-size: 100% 100%;
        }
        .rightBox {
          position: relative;
          display: inline-block;
          width: 330px;
          height: 240px;
          background: url(./images/result_bg6.png) no-repeat center center;
          background-size: 100% 100%;
          vertical-align: top;
          text-align: center;
          margin-right: 15px;
          .inner {
            width: 330px;
            height: 230px;
            // margin: 60px 0 0 10px;
          }
        }
        .rightBox::before {
          position: absolute;
          content: "物联网系统未安装隐患概率";
          top: 11px;
          left: 13px;
          height: 14px;
          line-height: 14px;
          font-size: 14px;
          color: #ffffff;
        }
        .rightBox::after {
          position: absolute;
          content: "";
          top: 16.5px;
          right: 3px;
          height: 5px;
          width: 125px;
          background: url(./images/title_bg.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
      .radioTab {
        display: inline-block;
        /* margin-bottom: 41px; */
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 41px;
        li {
          width: 8px;
          height: 9px;
          border-radius: 50%;
          background: #21629a;
          margin-right: 7.5px;
          display: inline-block;
        }
        li.active {
          background: #0eebff;
        }
        li:last-child {
          margin-right: 0;
        }
      }
    }
    .probability::before {
      display: block;
      position: absolute;
      content: "导致企业风险发生的概率";
      width: 100%;
      height: 27px;
      background: url(./images/title_long.png) no-repeat center center;
      background-size: 150% 100%;
      top: -15px;
      left: 0;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 27px;
    }
    .probability.js_worldofwar {
      transform: translate(0px, 0px);
      opacity: 1;
      transition: all 0.6s;
      -webkit-transition: all 0.6s;
      -ms-transition: all 0.6s;
      -moz-transition: all 0.6s;

      transition-delay: 0.2s;
      -moz-transition-delay: 0.2s;
      -webkit-transition-delay: 0.2s;
      /* position: absolute */
    }
    .reality {
      width: 100%;
      background: url(./images/result_bg3.jpg) no-repeat center center;
      background-size: 100% 100%;
      transition: transform 0.3s ease-in-out;
      position: relative;
      transform: translate3d(0, 40px, 0);
      visibility: visible;
      opacity: 0;
      transition: all 0s;
      -webkit-transition: all 0s;
      -ms-transition: all 0s;
      -moz-transition: all 0s;
      border: 1px solid transparent;
      padding: 0 15px 0 15px;
      .centerBox {
        width: 100%;
        margin: 35px auto;
        // height: 600px;
        background: #17456c;
        .tab {
          display: flex;
          height: 30px;
          li {
            flex: 1;
            background: #0e2b43;
            line-height: 30px;
            font-size: 12px;
            color: #2166a0;
            cursor: pointer;
          }
          li.active {
            background: #17456c;
            color: #ffffff;
          }
        }
        .rollBlock {
          border: 1px solid transparent;
          width: 100%;
          position: relative;
          .leftArrow {
            position: absolute;
            width: 32px;
            height: 74px;
            background: linear-gradient(
              90deg,
              rgba(41, 120, 193, 1) 0%,
              rgba(26, 79, 125, 1) 100%
            );
            border-radius: 0px 6px 6px 0px;
            top: 170px;
            left: 0;
            cursor: pointer;
            z-index: 10;
          }
          .leftArrow::before {
            content: "";
            width: 20px;
            height: 20px;
            border-top: 2px solid #ffffff;
            border-right: 2px solid #ffffff;
            transform: rotate(-135deg);
            margin-right: 8px;
            position: absolute;
            top: 25px;
            left: 10px;
            z-index: 15;
          }
          .rightArrow {
            position: absolute;
            width: 32px;
            height: 74px;
            background: linear-gradient(
              90deg,
              rgba(41, 120, 193, 1) 0%,
              rgba(26, 79, 125, 1) 100%
            );
            border-radius: 6px 0px 0px 6px;
            top: 170px;
            right: 0;
            cursor: pointer;
            z-index: 10;
          }
          .rightArrow::before {
            content: "";
            width: 20px;
            height: 20px;
            border-bottom: 2px solid #ffffff;
            border-left: 2px solid #ffffff;
            transform: rotate(-135deg);
            margin-left: 8px;
            position: absolute;
            top: 25px;
            right: 10px;
            z-index: 15;
          }
          .rollarea {
            position: relative;
            width: 100%;
            // height: 450px;
            .EchartsArea {
              width: 100%;
              height: 310px;
              margin: 0 auto;
              overflow-x: auto;
              white-space: nowrap;
              overflow-y: hidden;
              position: relative;
              .scroll {
                // width: 840px;
                height: 310px;
                overflow-x: auto;
                white-space: nowrap;
                overflow-y: hidden;
                transition: all 0.6s;
                -webkit-transition: all 0.6s;
                position: relative;
                // display: inline-block;
                .packageBox {
                  width: 100%;
                  display: inline-block;
                  white-space: nowrap;
                  .title {
                    margin: 18px auto 12px auto;
                    text-align: center;
                    font-size: 12px;
                    color: #ffffff;
                    // position: absolute;
                    // top: 0;
                    // left: 0;
                    // right: 0;
                    // text-align: center;
                  }
                  .echart {
                    // margin-top: 60px;
                    width: 100%;
                    height: 280px;
                    display: inline-block;
                  }
                }
              }
              .scroll::-webkit-scrollbar {
                display: none;
              }
            }
            .radio {
              display: inline-block;
              li {
                display: inline-block;
                width: 10px;
                height: 10px;
                background: rgba(14, 43, 67, 1);
                border-radius: 50%;
                margin-top: 17px;
                margin-right: 10px;
                margin-bottom: 14px;
              }
              li:last-child {
                margin-right: 0px;
              }
              li.active {
                background: rgba(14, 235, 255, 1);
              }
            }
          }
        }
        .warningArea {
          width: calc(100% - 30px);
          margin: 0 15px 13px 15px;
          padding: 5px 9px 5px 4px;
          background: rgba(15, 47, 74, 1);
          border-radius: 4px;
          font-size: 16px;
          color: #ff3e3e;
          text-align: right;
          font-weight: bold;
          .Warnning {
            width: 13px;
            height: 13px;
            background: #ff3e3e;
            display: inline-block;
            border-radius: 50%;
            font-size: 12px;
            line-height: 12px;
            text-align: center;
            color: #000;
            margin-right: 3px;
            margin-top: 2px;
            vertical-align: top;
          }
          p {
            display: inline-block;
            width: calc(100% - 25px);
            font-size: 12px;
            line-height: 15px;
            text-align: left;
          }
        }
        .realityDetail {
          width: 100%;
          padding: 0 15px 15px 15px;
          text-align: left;
          .detailTitle {
            font-size: 14px;
            color: #0eebff;
            line-height: 14px;
            margin-top: 20px;
            margin-bottom: 8px;
            font-weight: bold;
            text-align: left;
            .detailSpride {
              font-size: 10px;
              color: #ffffff;
              padding-bottom: 2.5px;
              border-bottom: 1px solid #d6dbe0;
              cursor: pointer;
            }
          }
          .detailTitle.sub {
            font-size: 12px;
            line-height: 18px;
          }
          .systemlack {
            width: 100%;
            display: inline-block;
            background: #1c5a8b;
            padding: 14.5px 10px 0px 10px;
            .system {
              width: 96px;
              display: inline-block;
              margin-bottom: 14.5px;
              text-align: center;
              img {
                height: 42px;
                width: 42px;
                margin-bottom: 6.5px;
              }
              p {
                display: inline-block;
                text-align: center;
                height: 16px;
                width: 96px;
                line-height: 16px;
                font-size: 12px;
                color: #ffffff;
              }
            }
            .system:last-child {
              margin-right: 0;
            }
          }
          a {
            display: inline-block;
            font-size: 12px;
            color: #0eebff;
            line-height: 24px;
            font-weight: normal;
            /* height: 30px; */
            text-decoration: none;
            /* padding-bottom: 0px; */
            border-bottom: 1px solid #0eebff;
          }
          .txt {
            font-size: 12px;
            color: #ffffff;
            line-height: 16px;
            letter-spacing: 1px;
            display: block;
          }
          .txtbox {
            font-size: 12px;
            color: #ffffff;
            line-height: 18px;
            letter-spacing: 1px;
            display: inline-block;
            position: relative;
            margin-right: 10px;
          }
          .txtbox::after {
            position: absolute;
            content: "、";
            font-size: 16px;
            color: #ffffff;
            bottom: 2px;
            right: -17px;
          }
          .txtbox:last-child {
            margin-right: 0px;
          }
          .txtbox:last-child::after {
            position: absolute;
            content: "";
          }
          .content {
            width: 100%;
            background: rgba(28, 90, 139, 1);
            border: 1px dashed rgba(14, 235, 255, 1);
            padding: 10px;
            margin-bottom: 23px;
            .contentItem {
              margin-bottom: 20px;
            }
            .contentItem:last-child {
              margin-bottom: 10px;
            }
            .detailTitle {
              font-size: 12px;
              color: #0eebff;
              line-height: 13px;
              margin-top: 0px;
              margin-bottom: 8px;
              font-weight: bold;
              text-align: left;
            }
            .singleline {
              display: block;
            }
            .underLine {
              padding-bottom: 1px;
              border-bottom: 1px solid #ffffff;
              font-size: 12px;
              color: #ffffff;
              line-height: 12px;
              display: inline-block;
              letter-spacing: 1px;
            }
            .txt {
              font-size: 12px;
              color: #ffffff;
              line-height: 18px;
              display: inline-block;
              letter-spacing: 1px;
            }
            .num {
              font-size: 12px;
              color: #0eebff;
              line-height: 18px;
            }
          }
          .num {
            font-size: 12px;
            color: #0eebff;
            line-height: 18px;
          }
          .text {
            font-size: 12px;
            color: #ffffff;
            line-height: 18px;
          }
        }
      }
    }
    .reality::before {
      position: absolute;
      content: "结合企业实际情况综合分析报告";
      width: 100%;
      height: 27px;
      background: url(./images/title_long.png) no-repeat center center;
      background-size: cover;
      top: -15px;
      left: 0;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 27px;
    }
    .reality.js_worldofwar {
      transform: translate(0px, 0px);
      opacity: 1;
      transition: all 0.6s;
      -webkit-transition: all 0.6s;
      -ms-transition: all 0.6s;
      -moz-transition: all 0.6s;

      transition-delay: 0.2s;
      -moz-transition-delay: 0.2s;
      -webkit-transition-delay: 0.2s;
      /* position: absolute */
    }
    .answer {
      width: 100%;
      background: #113452;
      transition: transform 0.3s ease-in-out;
      position: relative;
      transform: translate3d(0, 40px, 0);
      visibility: visible;
      opacity: 0;
      transition: all 0s;
      -webkit-transition: all 0s;
      -ms-transition: all 0s;
      -moz-transition: all 0s;
      border: 1px solid #113452;
      padding: 0 15px 0 15px;
      margin-bottom: 60px;
      .textcontent {
        padding: 32px 16.5px 16.5px 16px;
        .Forcircle {
          margin-bottom: 30px;
          text-align: left;
        }
        .Forcircle:last-child {
          margin-bottom: 0px;
        }
        .answerTitle {
          font-size: 14px;
          color: #0eebff;
          line-height: 15px;
          margin-bottom: 5px;
          font-weight: bold;
          text-align: left;
        }
        .answertext {
          font-size: 12px;
          color: #ffffff;
          line-height: 18px;
          // display: inline-block;
          letter-spacing: 1px;
          text-align: left;
        }
      }
      .warningArea {
        width: calc(100% - 30px);
        margin: 0 15px 13px 15px;
        padding: 5px 9px 5px 4px;
        background: #0b2032;
        border-radius: 4px;
        font-size: 16px;
        color: #ff3e3e;
        text-align: right;
        font-weight: bold;
        .Warnning {
          width: 13px;
          height: 13px;
          background: #ff3e3e;
          display: inline-block;
          border-radius: 50%;
          font-size: 12px;
          line-height: 13px;
          text-align: center;
          color: #000;
          margin-right: 3px;
          margin-top: 3px;
          vertical-align: top;
        }
        p {
          display: inline-block;
          width: calc(100% - 33px);
          font-size: 12px;
          line-height: 15px;
          text-align: left;
        }
      }
    }
    .answer::before {
      position: absolute;
      content: "企业消防知识评测分析";
      width: 100%;
      height: 27px;
      background: url(./images/title_long.png) no-repeat center center;
      background-size: cover;
      top: -15px;
      left: 0;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 27px;
    }
    .answer.js_worldofwar {
      transform: translate(0px, 0px);
      opacity: 1;
      transition: all 0.6s;
      -webkit-transition: all 0.6s;
      -ms-transition: all 0.6s;
      -moz-transition: all 0.6s;

      transition-delay: 0.2s;
      -moz-transition-delay: 0.2s;
      -webkit-transition-delay: 0.2s;
      /* position: absolute */
    }
    // .blankArea {
    //   height: 58px;
    //   width: 100%;
    // }
  }
  .cssMainBody.heighrisk {
    .rank {
      .resultNumbArea {
        background: url(./images/low_bg.png) no-repeat center center;
        background-size: auto 107%;
      }
    }
  }
  .cssMainBody.lowrisk {
    .rank {
      .resultNumbArea {
        background: url(./images/medium.png) no-repeat center center;
        background-size: auto 107%;
        .Numb {
          height: 29px;
          line-height: 29px;
          font-size: 29px;
          font-weight: bold;
          color: #1d5788;
          margin-bottom: 12px;
          span {
            font-size: 30px;
            line-height: 30px;
            display: inline-block;
            vertical-align: top;
          }
        }
        .ranklevel {
          line-height: 15px;
          border: 2px solid #fbd740;
          border-radius: 50px;
          font-size: 10px;
          color: #730609;
          background: #f4b424;
          margin: 0 auto;
          display: inline-block;
          padding: 2px 4px;
          width: 76px;
        }
      }
      .companyTestRank {
        .companyRank {
          .flag {
            // margin-right: 23px;
            background: none;
          }
          // .flag:after {
          //   content: "";
          //   position: absolute;
          //   top: -1px;
          //   right: -24px;
          //   width: 0px;
          //   height: 0px;
          //   border: none;
          // }
        }
      }
    }
  }
  .cssMainBody.subperfect {
    .rank {
      .resultNumbArea {
        background: url(./images/great_bg.png) no-repeat center center;
        background-size: auto 107%;
        .Numb {
          height: 29px;
          line-height: 29px;
          font-size: 29px;
          font-weight: bold;
          color: #fff;
          margin-bottom: 12px;
          span {
            font-size: 30px;
            line-height: 30px;
            display: inline-block;
            vertical-align: top;
          }
        }
        .ranklevel {
          line-height: 15px;
          border: 2px solid #14d0a3;
          border-radius: 50px;
          font-size: 10px;
          color: #730609;
          background: #23aa73;
          margin: 0 auto;
          color: #ffffff;
          display: inline-block;
          padding: 2px 4px;
          width: 76px;
        }
      }
      .companyTestRank {
        .companyRank {
          .flag {
            // margin-right: 23px;
            background: none;
          }
          // .flag:after {
          //   content: "";
          //   position: absolute;
          //   top: -1px;
          //   right: -24px;
          //   width: 0px;
          //   height: 0px;
          //   border: none;
          // }
        }
      }
    }

    .probability {
      p {
        margin-bottom: 50px;
      }
    }
  }
  .cssMainBody.perfect {
    .rank {
      .resultNumbArea {
        background: url(./images/great_bg.png) no-repeat center center;
        background-size: auto 107%;
        .Numb {
          height: 29px;
          line-height: 29px;
          font-size: 29px;
          font-weight: bold;
          color: #fff;
          margin-bottom: 5px;
          span {
            font-size: 30px;
            line-height: 30px;
            display: inline-block;
            vertical-align: top;
          }
        }
        .ranklevel {
          border: none;
          background: url(./images/perfect.png) no-repeat center center;
          background-size: 100% 100%;
          line-height: 29px;
          height: 33px;
          width: 72px;
          color: #ffff00;
          padding-top: 3px;
          text-align: center;
          text-indent: 15px;
        }
      }
      .companyTestRank {
        .companyRank {
          position: relative;
          .medal {
            width: 40px;
            height: 62px;
            background: url("./images/trophy.png") no-repeat center center;
            background-size: 100% 100%;
            margin-top: 20px;
            left: 24%;
            position: absolute;
          }
          .TotalRank {
            width: 100%;
            height: 34px;
            line-height: 34px;
            margin-top: 44px;
            background: linear-gradient(
              90deg,
              rgba(28, 86, 134, 1) 0%,
              rgba(0, 129, 191, 1) 74%,
              rgba(28, 86, 134, 1) 100%
            );
            text-align: center;
            .AnimatePerNum {
              display: inline-block;
              font-size: 25px;
              font-weight: bold;
              color: #ffe56b;
              margin-right: 10px;
              height: 34px;
              line-height: 34px;
              vertical-align: bottom;
              width: 130px;
              text-align: right;
            }
            p:last-child {
              vertical-align: top;
              font-size: 12px;
              display: inline-block;
              height: 34px;
              line-height: 40px;
              color: #ffffff;
            }
          }
          .flag {
            display: inline-block;
            position: relative;
            width: 268.4px;
            height: 94px;
            margin-right: 45px;
            margin-top: 39px;
            border-top: 1px solid transparent;
            background: none;
          }
          // .flag:after {
          //   content: "";
          //   position: absolute;
          //   top: -1px;
          //   right: -24px;
          //   width: 0px;
          //   height: 0px;
          //   border: none;
          // }
        }
      }
    }
    .probability {
      position: relative;
      width: 100%;
      height: 369px;
      background: url(./images/result_bg4.jpg) no-repeat top center;
      background-size: 100% 107%;
      transition: transform 0.3s ease-in-out;
      position: relative;
      transform: translate3d(0, 40px, 0);
      visibility: visible;
      opacity: 0;
      transition: all 0s;
      -webkit-transition: all 0s;
      -ms-transition: all 0s;
      -moz-transition: all 0s;
      border: 1px solid transparent;
      .icon {
        display: block;
        width: 114px;
        height: 114px;
        background: url(./images/good_icon.png) no-repeat center center;
        background-size: auto 100%;
        margin: 65px auto 24px auto;
      }
      p {
        text-align: center;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        color: #fff;
        span {
          font-size: 18px;
          color: #0eebff;
          font-style: italic;
        }
      }
    }
    .probability::before {
      position: absolute;
      content: "导致企业风险发生的概率";
      width: 100vw;
      height: 27px;
      background: url(./images/title_long.png) no-repeat center center;
      background-size: cover;
      top: -15px;
      left: 0;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 27px;
    }
    .probability.js_worldofwar {
      transform: translate(0px, 0px);
      opacity: 1;
      transition: all 0.6s;
      -webkit-transition: all 0.6s;
      -ms-transition: all 0.6s;
      -moz-transition: all 0.6s;

      transition-delay: 0.2s;
      -moz-transition-delay: 0.2s;
      -webkit-transition-delay: 0.2s;
      /* position: absolute */
    }
  }
}
.CircleToTalNumb {
  position: absolute;
  top: 24.5%;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  font-size: 20px;
  color: rgb(255, 65, 65);
  font-weight: bold;
}
.CircleToTalPoint {
  font-size: 12px;
}
.bottombuttons {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  background: #081825;
  z-index: 10;
  .inner {
    width: 100%;
    margin: 0 auto;
    line-height: 60px;
    font-size: 0;
    text-align: center;
    .buttonBox {
      margin-top: 7px;
      white-space: nowrap;
      .export {
        font-size: 16px;
        color: #ffffff;
        padding: 15px 40px 15px 40px;
        background: linear-gradient(
          90deg,
          rgba(34, 106, 165, 1) 0%,
          rgba(0, 200, 174, 1) 100%
        );
        border-radius: 50px;
        margin-right: 10px;
        display: inline-block;
        // width: 167px;
        // height: 45px;
        line-height: 16px;
        vertical-align: text-bottom;
        cursor: pointer;
      }
      .OneKeyDeal {
        font-size: 16px;
        color: #ffffff;
        padding: 15px 40px 15px 40px;
        background: linear-gradient(
          90deg,
          rgba(255, 55, 55, 1) 0%,
          rgba(255, 111, 111, 1) 100%
        );
        border-radius: 50px;
        display: inline-block;
        // width: 167px;
        // height: 45px;
        line-height: 16px;
        vertical-align: text-bottom;
        cursor: pointer;
      }
    }
  }
}
.mark-view {
  position: fixed;
  z-index: 100;
  left: 0px;
  right: 0px;
  bottom: 0;
  height: calc(100% - 55px);
  width: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  .content {
    position: absolute;
    z-index: 105;
    left: 0;
    top: calc(50% - 100px);
    right: 0;
    // height: 50px;
    line-height: 30px;
    color: #ffffff;
    font-size: 17px;
    text-align: center;
    font-weight: normal;
    margin-bottom: 30px;
    span {
      color: #ffff00;
      font-weight: bold;
      font-style: italic;
    }
    .bold {
      color: #ffffff;
    }
  }
  .lookBtn {
    position: absolute;
    z-index: 105;
    left: 0px;
    right: 0px;
    margin: 0 auto;
    width: 180px;
    height: 45px;
    line-height: 45px;
    top: calc(50% - 10px);
    background-color: #c41335;
    border-radius: 4px;
    color: #ffffff;
    font-size: 16px;
    text-align: center;
  }
}
.mark-view:after {
  position: absolute;
  z-index: 99;
  left: 0px;
  right: 0px;
  bottom: 0;
  height: 100%;
  width: 100%;
  -webkit-filter: blur(10px);
  filter: blur(10px);
  background: url(./images/filterMask.png) no-repeat top center;
  background-size: 100% 100%;
  content: "";
}
.maskshow::before {
  content: "";
  position: absolute;
  background: rgb(255, 255, 255);
  opacity: 0.8;
  // filter: url(blur.svg#blur); /* FireFox, Chrome, Opera */

  -webkit-filter: blur(10px); /* Chrome, Opera */
  -moz-filter: blur(10px);
  -ms-filter: blur(10px);
  filter: blur(10px);
}
.changeBrowser {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  .alertBody {
    position: absolute;
    width: 310px;
    // height: 190px;
    border-radius: 2px;
    background: #ffffff;
    top: calc(50% - 150px);
    left: 0;
    right: 0;
    margin: 0 auto;
    h1 {
      display: block;
      line-height: 60px;
      height: 60px;
      font-size: 18px;
      color: #ffffff;
      background: #c41335;
      padding-left: 15px;
    }
    p {
      font-size: 16px;
      color: #000;
      line-height: 25px;
      height: 50px;
      margin: 25px 15px 25px 15px;
      text-align: center;
    }
    span {
      display: block;
      width: 120px;
      font-size: 14px;
      background: #c41335;
      color: #ffffff;
      padding: 10px 12px 10px 12px;
      margin: 0 auto 15px auto;
      line-height: 14px;
      text-align: center;
      border-radius: 7px;
    }
  }
}
</style>
<style type='text/css'>
.fixedClass {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  /* overflow: hidden; */
}
.noline {
  text-decoration: none !important;
}
.el-dialog__header {
  background: rgb(196, 19, 53);
}
.el-dialog__body {
  padding-top: 60px;
  padding-bottom: 60px;
}
.el-dialog__title {
  color: #ffffff;
}
.el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/view/fxcp_result/index.vue